{
    "Api tokens": {
        "add token": "Add token",
        "description": "Generates an API token for OEM file download for TCT and Configurator or API token for the application to use when requesting FOTA WEB services. API documentation can be found <1>here</1>.",
        "example": "E.g.: fota_token",
        "generate token": "Generate token",
        "generated token": "Generated token",
        "last used at": "Last used at",
        "name": "Token name",
        "never": "Never",
        "no tokens": "No tokens available",
        "no tokens description": "Once tokens are added they will be listed here below",
        "show token list": "Show token list",
        "titles": {
            "Integration": {
                "description": "Used for FOTA WEB integration in your system",
                "name": "API integration token"
            },
            "Tct": {
                "description": "Used for OEM file download for TCT and Configurator",
                "name": "TCT token"
            }
        },
        "tokens": "API tokens",
        "token type": "Token type",
        "token was created": "Token was successfully created"
    },
    "Attributes": {
        "Completed": "Completed",
        "Count": "Count",
        "Current": "Current",
        "Date": "Date",
        "Empty": "Empty",
        "excluded files": "Excluded files (samegrade)",
        "Failed": "Failed",
        "false": "False",
        "Feature": "Feature",
        "file size bytes": "Total file size",
        "File_type": "File type",
        "File_version": "File version",
        "Fingerprint_id": "Fingerprint ID",
        "Firmware_date": "Firmware date",
        "Firmware_version": "Revision",
        "included files": "Included files",
        "Include_j1939": "Pack J1939",
        "Message": "Message",
        "Metadata": "Metadata",
        "newest": "From newest",
        "oldest": "From oldest",
        "Order": "Order",
        "Password_source": "Password source",
        "Pending": "Pending",
        "Period": "Period",
        "Process_id": "Process ID",
        "Protocol_id": "Protocol ID",
        "Reported_count": "Reported count",
        "Requested_count": "Requested count",
        "specific": "Specific",
        "Start": "Start",
        "SystemGenerated": "Automatically generated password",
        "true": "True",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "BLE firmware",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "CAN firmware",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "TAPP firmware"
        },
        "UserEntered": "User-entered password",
        "vehicle": "Vehicle",
        "Vehicle_id": "Vehicle ID",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "Check your authenticator app",
            "check email": "Check your email",
            "code required": "Verification code required.",
            "code sent to email": "Code sent to your email",
            "code valid": "The code is valid for several minutes.",
            "enter code below": "and enter the code below to sign in.",
            "no access to otp": "No access to your device?",
            "recovery code": {
                "banner text": "After signing in with a recovery code, you will be prompted to reconfigure your two- factor authentication to keep your account secure.",
                "description": "Enter one of your recovery codes to sign in. Each code can only be used once.",
                "secondary text": "Enter one of your recovery codes to sign in. Each code can only be used once.",
                "title": "Recovery code"
            },
            "title": "Account verification",
            "use recovery code": "Use a recovery code."
        },
        "account verification description": "Verification code required. Check your authenticator app and enter the code below to sign in.",
        "check email": "Please check your inbox and click the received link to reset a password.",
        "community forum": "Crowd-support forum",
        "contact us": "Contact us",
        "create initial password": "Create password",
        "create password": "Create a password that",
        "did not receive": "Didn’t receive the link?",
        "do not have account": "Don’t have an account yet?",
        "email": "Email",
        "enter email": "Please enter your registered email below to receive password reset instruction.",
        "forgot password": "Forgot Password?",
        "forgot your password": "Forgot your password?",
        "for ms365": "For Teltonika MS365 users",
        "invalid email format": "Invalid email format",
        "invalid password format": "Invalid password format",
        "link sent": "Link has been sent!",
        "length": "Minimum 8 characters",
        "lowercase": "Contains at least 1 lowercase letter",
        "new password": "New password",
        "password": "Password",
        "passwords do not match": "Passwords do not match",
        "privacy policy": "By using FOTA WEB, you agree with our <1>Privacy policy</1>.",
        "remember password": "Do you remember your password?",
        "repeat password": "Repeat password",
        "required": "Required",
        "resend": "Resend",
        "reset password": "Reset password",
        "send reset link": "Send reset link",
        "sign in": "Sign in",
        "sign in to fota": "Sign in to your\nFOTA WEB account",
        "signup": "Sign Up",
        "sso": "Sign in with Microsoft",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Uppercase letter",
        "user consent text": "I understand and accept Teltonika <1>Terms of Service</1> and the <2>Data Processing Agreement</2>.",
        "welcome": "Welcome to",
        "wiki": "Telematics Wiki Knowledge Base"
    },
    "Banner": {
        "activate banner": "Activate banner",
        "apply link": "Apply link",
        "banner importance": "Banner importance",
        "bold": "Bold",
        "close link": "Close link",
        "info": "Informational",
        "italic": "Italic",
        "link": "Link",
        "message": "Message",
        "text": "Text (optional)",
        "underline": "Underline",
        "url": "URL",
        "warning": "Warning"
    },
    "Button": {
        "accept": "Accept",
        "accept all": "Accept all",
        "accept selected": "Accept selected",
        "actions": "Actions",
        "add": "Add",
        "add device": "Add device",
        "add more files": "Add more files",
        "add new": "Add new",
        "agree": "I agree",
        "all companies": "All companies",
        "all of company": "All of {{companyName}}",
        "all rows selected": {
            "devices": "All {{count}} devices are selected",
            "tasks": "All {{count}} pending/running tasks are selected",
            "groups": "All {{count}} groups are selected",
            "files": "All {{count}} files are selected",
            "companies": "All {{count}} companies are selected",
            "users": "All {{count}} users are selected"
        },
        "approve": "Approve",
        "assign": "Assign",
        "assigning": "Assigning",
        "auto sync": "Auto-Sync",
        "back": "Back",
        "back to sign in": "Back to sign in",
        "cancel": "Cancel",
        "cancelling": "Cancelling",
        "cancel all tasks in group": "Cancel all tasks in the group",
        "cancel tasks": "Cancel tasks",
        "cannot create desktop licenses": "Licenses cannot be created for Internal companies.",
        "cannot create offline licenses": "Offline licenses cannot be created for unrestricted licenses.",
        "change": "Change",
        "clear all": "Clear all",
        "clear all filters": "Clear all filters",
        "close": "Close",
        "company settings": "Company settings",
        "confirm": "Confirm",
        "continue": "Continue",
        "copied": "Copied",
        "copy all": "Copy all",
        "copy to clipboard": "Copy to clipboard",
        "create": "Create",
        "create role": "Create role",
        "create task": "Create task",
        "creating": "Creating",
        "default view": "Default view",
        "delete": "Delete",
        "deleting": "Deleting",
        "deselect all": "Deselect all",
        "device": "Device",
        "disable": "Disable",
        "disagree": "I disagree",
        "discard": "Discard",
        "download": "Download",
        "edit": "Edit",
        "enable": "Enable",
        "export": "Export",
        "exporting": "Exporting",
        "filters": "Filters",
        "finish": "Finish",
        "find tool": "Find tool",
        "first page": "First page",
        "generate": "Generate",
        "generate codes": "Generate codes",
        "go back": "Go back",
        "import": "Import",
        "importing": "Importing",
        "invite": "Invite",
        "invite user": "Invite user",
        "invite user to internal disabled": "Only Admin Manager and higher access levels can invite users to internal companies.",
        "language": "Language",
        "last page": "Last page",
        "logout": "Sign out",
        "maximize details": "Maximize details",
        "merge": "Merge",
        "merging": "Merging",
        "minimize details": "Minimize details",
        "more actions": "More actions",
        "more filters": "More filters",
        "more options": "More options",
        "move": "Move",
        "moving": "Moving",
        "next": "Next",
        "next month": "Next month",
        "next page": "Next page",
        "no actions available": "No actions available",
        "no permission": "You need \"{{permissionName}}\" permission.",
        "no permissions": "You need the following permissions: {{permissionNames}}.",
        "notify when done": "Notify me when done",
        "number of selected companies": "{{companyCount}} of {{companyName}}",
        "only essential": "Only essential",
        "open fota web": "Open FOTA WEB",
        "pages of": "of {{total}}",
        "previous month": "Previous month",
        "previous page": "Previous page",
        "print": "Print",
        "receive devices": "Receive devices",
        "refresh page": "Refresh",
        "reject all": "Reject all",
        "reset to default": "Reset to default",
        "retry failed tasks": "Retry failed tasks",
        "retrying": "Retrying",
        "return home": "Let's go home",
        "revert manual level change": "Revert manual level change",
        "rows count per page": "Rows count per page",
        "rows selected": "{{count}} Selected",
        "save": "Save",
        "saving": "Saving",
        "see all": "See all",
        "select all": {
            "devices": "Select all {{count}} devices",
            "tasks": "Select all {{count}} pending/running tasks",
            "groups": "Select all {{count}} groups",
            "files": "Select all {{count}} files",
            "companies": "Select all {{count}} companies",
            "users": "Select all {{count}} users"
        },
        "select columns to show": "Select columns to show",
        "selected page is first": "The selected page is the first",
        "selected page is last": "The selected page is the last one",
        "select rows": "Select rows",
        "send code": "Send code",
        "settings": "Settings",
        "show me": "Show me",
        "show more": "Show more",
        "synchronize": "Synchronize",
        "table statistics": "Table statistics",
        "table view": "Table view",
        "transfer": "Transfer",
        "transferring": "Transferring",
        "transfer my devices": "Transfer my devices",
        "undo": "Undo",
        "upload": "Upload",
        "upload file": "Upload new file",
        "user": "User",
        "verify": "Verify",
        "yes": "Yes"
    },
    "Cookies": {
        "always active": "Always active",
        "analytics cookies": "Analytics cookies",
        "analytics cookies description": "These trackers are used for analytics to help collect data that allows us to understand how users interact with our websites. These insights allow us both to improve content and to build better features that improve the user's experience. This category of cookies can be disabled.",
        "cookie banner message": "We and selected third parties use cookies or similar technologies for technical purposes and, with your consent, for other purposes as specified in the ",
        "cookie modal title": "We use cookies",
        "cookie policy": "cookie policy",
        "essential cookies": "Essential cookies",
        "essential cookies description": "These trackers are used for activities that are strictly necessary to operate or deliver the service you requested from us and, these cookies do not gather information about you that could be used for marketing purposes and do not remember where you have been on the internet. This category of cookies cannot be disabled."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "Essentials for remote device update",
                "Standard": "Advanced automation and integration",
                "Premium": "Enterprise scaling and early access to updates"
            },
            "resource limit types": {
                "Companies": "Companies",
                "Users": "Users",
                "ConfigurationFiles": "Configuration files"
            }
        },
        "empty state": {
            "description": {
                "configurations": "As soon as configurations are detected by FOTA WEB, you will be able to see the list here.",
                "firmware versions": "As soon as firmware versions are detected by FOTA WEB, you will be able to see the list here."
            },
            "title": {
                "configurations": "No configurations detected",
                "firmware versions": "No firmware versions detected",
                "news": "No news to show"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "Today",
                "7": "7 days",
                "30": "30 days",
                "90": "90 days"
            },
            "period": "Period"
        },
        "new": "New",
        "news": {
            "body": {
                "1": "We would like to remind you that for users invited after January 7, 2025, 2FA will be mandatory immediately upon account activation. Two-factor authentication is available via email verification or an authenticator app.",
                "2": "We would like to inform you about planned FOTA WEB maintenance that will take place on June 3, 2025 starting at 05:00 UTC. Please take into account that during maintenance all services will be unavailable, including user interface, API access, tasks execution, OBD, and CAN services. Estimated time of service unavailability is 1 hour.",
                "3": "<section><p>We're excited to announce an important improvement to the Device Unlocker feature on FOTA WEB:</p></section> <section><p>All user roles can now unlock devices directly — no need to contact Technical Support via Helpdesk!</p> <p>Key Details:</p> <ul><li>Users can unlock the same device up to 3 times within a 24-hour period.</li> <li>After reaching the limit, the unlock option will be temporarily disabled for 24 hours.</li> <li>If the unlock limit is exceeded, an error message will appear. This update significantly reduces waiting times and gives you more control over your fleet management.</li></ul></section> <section><a>Learn how to use the feature</a></section>",
                "4": "<section><p>We're excited to announce some great new updates to the FOTA WEB dashboard! We've been working to improve your experience with enhanced widgets and new insights.</p></section> <section><h3>New Device Statistics</h3></section> <section><p>Get better insights into your device activity with two brand-new widgets:</p> <p><strong>Activated devices</strong>: This new statistic shows you how many devices have been activated (connected) over various periods: Today, 7 days, 30 days, or 90 days.</p> <p><strong>Imported devices</strong>: Similarly, the new Imported Devices statistic tracks how many devices have been imported over Today, 7 days, 30 days, or 90 days.</p> </section> <section><h3>Introducing the Tasks Widget</h3></section> <section><p>Keep track of your operations with the all-new Tasks widget:</p> <p><strong>Queued tasks</strong>: See a clear count of your currently pending tasks.</p> <p><strong>Tasks overview</strong>: Get a breakdown of your task distribution by period (7 days, 30 days, or 90 days) and status. This includes tasks that are Completed, Completed with errors, or Failed.</p></section> <section><h3>Smarter Firmware and Configuration Overviews</h3></section> <section><p>We've refined the Firmware versions and Configurations widgets:</p> <ul><li>We've removed \"Unknown\" statistics for cleaner data.</li> <li>The UI now more clearly shows firmware and configuration names and their counts.</li> <li>You'll see the top 5 versions or configurations initially, with an option to \"Show more\" to view up to 100 different entries.</li> <li>Hovering and clicking on specific firmware or configuration will lead you to the \"Devices page\" and apply a filter.</li></ul></section> <section><h3>Enhanced News Widget</h3></section> <section><p>Stay informed at a glance! The News widget has a fresh new look, and now you can also click on any news item to read the full information.</p></section> <section><h3>Improved Device Status</h3></section> <section><p>The Device Status widget has been visually updated for clarity. Plus, you can now hover over a device's status and click on it to filter out devices with the corresponding status on the \"Devices\" page.</p></section> <section><p>We hope these updates make your daily tasks even easier and provide you with more valuable information. Let us know what you think!</p></section>",
                "5": "<section><h3>Planned API Changes</h3></section> <section><p>On <strong>September 24th, 2025</strong>, we will be removing the \"role\" field from responses that return the user entity (for example, GET /users or GET /users/{userId} endpoints). This change is being made to pave the way for a more robust and flexible permissions system in FOTA WEB.</p></section> <section><h3>Sneak Peek: Roles and Permissions</h3></section> <section><p>  We recognize that the current role system doesn't provide the flexibility you require. Our development team is hard at work on a new <strong>Roles and Permissions management</strong> feature that will allow you to create roles with granular control over permissions.</p></section>  <section><p>This new system will give you the power to assign static roles to users or tailor permissions to your specific needs, and create custom roles. We're very excited about this and look forward to sharing more details about Roles and Permissions management when they become available.</p></section>",
                "6": "<section><p>We are pleased to announce the release of the new <strong>\"Roles and Permissions\"</strong> feature, designed to give you precise control over user access within the FOTA WEB. This functionality allows you to define user capabilities using <strong>Roles</strong>, which are sets of specific <strong>Permissions</strong> (e.g., \"Create task\", \"Invite user\"). The feature includes immutable <strong>Static roles</strong> - Administrator, User, and Guest - for baseline security, alongside customizable <strong>Custom Roles</strong> that only <strong>Premium company level</strong> users can create or edit. Permissions are now categorized across key areas like Devices, Tasks, and Users, and can be viewed by hovering over the \"Permissions count\" in the management section. <strong>For all existing users created prior to this update, they have been automatically assigned the \"Administrator\" role, ensuring they retain the full range of actions they could perform previously.</strong></p></section> <section><p>This update ensures better security and workload distribution. Roles are now company-specific and cannot be inherited across company structures. Note that a role must always be assigned when inviting or moving a user to a company, and roles with active user assignments cannot be deleted. You can now use the <strong>new \"Role\" filter</strong> on the <strong>Users</strong> page for easier management. Explore the \"Roles and Permissions\" section today to configure access tailored to your organization's needs.</p></section> <section><p>For a detailed guide on managing users and roles, please visit <a>the wiki page</a>.</p></section>",
                "7": "<section><p>We're excited to roll out a powerful new way to manage your tasks with the <strong>Schedule by date</strong> feature, giving you greater precision for time-sensitive work!</p></section> <section><h3>Key highlights</h3></section> <section><ul><li><strong>Specific deadlines</strong> - You can now schedule tasks for a <strong>specific date or date interval</strong> using a new \"Schedule by date\" option.</li> <li><strong>Default behavior unchanged</strong> - The familiar <strong>Schedule by time</strong> functionality remains fully available.</li> <li><strong>Expiration status</strong> - Tasks not completed by the set date will now automatically change status to <strong>Expired</strong>, accompanied by the message: <strong>\"The task was not completed during set schedule.\"</strong></li> <li><strong>User-centric timing</strong> - All schedules are created based on <strong>your local time</strong>.</li></ul></section> <section><h3>How it works</h3></section> <section><p>When setting task <strong>\"Schedule by date\"</strong>:</p> <ul><li>You will select a <strong>\"Start date\"</strong> and an <strong>\"End date\"</strong> via the date picker component.</li> <li>The date picker respects the company-level task expiration time limit.</li></ul></section><section><p>The <strong>Schedule by date</strong> functionality is currently exclusive to higher company levels and is not available for the <strong>Basic</strong> tier.</p></section>",
                "8": "<section><p>We've upgraded your administrative toolkit! You can now manage the entire lifespan of a user account from the moment of invitation to the final expiration, ensuring your company data stays secure and access remains temporary when it needs to be.</p></section> <section><h3>What's New?</h3></section> <section><ul><li><strong>Timed invitations</strong> - No more \"forever access\" by default. Set a hard expiration date the moment you invite a new team member or contractor.</li> <li><strong>Retroactive expiry</strong> - Easily apply expiration dates to users who are already active in your system.</li> <li><strong>On-demand kill switch</strong> - Need to cut access immediately? You can now terminate any user instantly. If you need them back, reactivate them in two clicks-either indefinitely or with a new expiration timer.</li></ul> <p><strong>Why this matters</strong>: This feature is perfect for managing external contractors or temporary staff without needing to remember to manually delete their accounts later.</p></section> <section><h3>Stay Informed</h3></section> <section><p>We've added a smart notification layer so neither you nor your users are ever left in the dark. The system now sends automated emails:</p> <ol><li><strong>The heads-up</strong>: Sent shortly before access is set to expire.</li> <li><strong>The transition</strong>: Sent the moment access expires.</li> <li><strong>The welcome back</strong>: Sent immediately upon account reactivation.</li></ol></section> <section><h3>How to Manage Access</h3></section> <section><p>Access these new settings within the <strong>User</strong> page:</p> <ul><li><strong>During invite</strong>: Look for the \"Expiration date\".</li> <li><strong>For existing users</strong>: Click \"Edit\" on any user to modify their access duration.</li> <li><strong>Instant action</strong>: Click \"Edit\" on any user and look for the “Access” toggle.</li></ul></section>",
                "9": "<section><p>We are excited to announce a significant upgrade to how you manage your device fleets. We have bridged the functional gap between our platforms, bringing the powerful <strong>Smart Device Group</strong> capabilities to the <strong>FT platform</strong>. Previously, automated file distribution was a luxury primarily enjoyed by FMx users. With this update, we've reorganized our grouping logic to ensure consistency, automation, and clarity across your entire ecosystem.</p></section> <section><h3>What's New?</h3></section> <section><p>We have decoupled standard groups from automated groups to give you more control over how your devices receive updates.</p> <ul><li><strong>Device group (standard)</strong> - A simple way to categorize and organize your products. These groups do not contain attached files, making them ideal for basic management.</li> <li><strong>Smart Device Group</strong> - This is where the automation happens. When you create a Smart Group, you can attach specific files that are <strong>automatically dispatched</strong> to every device in that group.</li> <li><strong>Cross-platform support</strong> - When creating a group, you can now select \"Create Smart Group\". This toggle unlocks the ability to upload and manage dedicated files for both <strong>FT and FMx platforms</strong> simultaneously.</li></ul></section> <section><h3>Why This Matters</h3></section> <section><p>The \"Smart\" functionality is designed to save you time and reduce human error:</p> <ul><li><strong>Instant synchronization</strong> - The moment you add a new device to a Smart Group, the system identifies it and pushes the required files immediately.</li> <li><strong>Parity</strong> - FT platform users now have the same robust automation tools as FMx users, ensuring a unified workflow regardless of the hardware you are deploying.</li> <li><strong>Clarity</strong> - By separating \"Device groups\" from \"Smart Groups\", it is now immediately clear which groups are actively pushing data to your hardware and which are purely organizational.</li></ul></section> <section><h3>How to Use Smart Groups</h3></section> <section><p>You can start automating your deployment within the <strong>Device groups</strong> page:</p> <ol><li><strong>Select group type</strong> - Click to create a new group and toggle the <strong>\"Create Smart Group\"</strong> option.</li> <li><strong>Attach files</strong> - You will be prompted to add the relevant files for your specific platforms (FT or FMx).</li> <li><strong>Add devices</strong> - Simply move your devices into the device group. The platform handles the rest, ensuring every unit is up to date.</li></ol></section>",
                "10": "<section><p>Please be advised that we are updating the email address used by <strong>FOTA WEB</strong> to send automated system notifications. Starting <strong>March 24, 2026</strong>, all system-generated correspondence will transition to a new domain.</p></section><section><h3>What is changing?</h3></section><section><p>We are moving away from our old sender address to a more streamlined one:</p><ul><li><strong>Old address:</strong> no-reply-fota@teltonika-iot-group.com</li><li><strong>New address:</strong> fota@teltonika-telematics.com</li></ul></section><section><h3>What action should you take?</h3></section><section><p>To ensure you don't miss any critical security codes or system updates, we recommend the following:</p><ol><li><strong>Whitelist the new address</strong> - Add fota@teltonika-telematics.com to your safe senders list or contact your IT department to ensure the new domain is permitted by your organization's firewall.</li><li><strong>Update filter rules</strong> - If you have automated folder rules or labels set up in your inbox for FOTA WEB, please update them to include the new address.</li></ol></section><section><p>Emails sent before March 24 will still appear from the old address. No action is required for past correspondence.</p></section>",
                "11": "<section><p>Starting <strong>April 9th, 2026</strong>, we are upgrading our security protocols to ensure your account remains safe. We are moving away from using password resets as a backup for Two-Factor Authentication (2FA) and introducing <strong>Recovery Codes</strong> as your new, secure \"spare key.\"</p></section> <section><h3>What is changing?</h3></section> <section><p>Previously, a password reset could be used to bypass a lost 2FA device. To align with global security best practices, this shortcut will be retired.</p> <p><strong>After this change, recovery codes will be the only way to regain access to your account if you lose your 2FA device.</strong></p> <p><strong>Note</strong>: This change only applies to users using an <strong>Authentication app</strong>. If you use the email option for 2FA, your process remains the same, and you do not need recovery codes.</p></section> <section><h3>How to prepare (do this now!)</h3></section> <section><p>Don't wait until you're locked out. You can generate your list of recovery codes today:</p> <ol><li>Navigate to <strong>Settings</strong> -> <strong>Security</strong>.</li> <li>Under <strong>Generate recovery codes</strong> press <strong>Generate</strong> button.</li> <li>You will be prompted for an <strong>OTP (One-Time Password)</strong> from your current authenticator to verify it's you.</li> <li><strong>Save these codes immediately.</strong> They will only be displayed once for your security. Print them, write them down, or store them in a secure password manager.</li></ol> <p><strong>Note</strong>: Generating a new list of codes will automatically invalidate any old ones.</p></section> <section><h3>How recovery works</h3></section> <section><p>If you lose your phone or delete your authenticator app, here is how you'll get back in:</p> <ol><li><strong>Sign in</strong> - Enter your standard email and password.</li> <li><strong>The 2FA prompt</strong> - When asked for your code, click <strong>\"Use a recovery code\"</strong>.</li> <li><strong>Authenticate</strong> - Enter one of your unused recovery codes.</li> <li><strong>Reset</strong> - Once used, your 2FA will be automatically disabled to allow you back in.</li> <li><strong>Re-setup</strong> - You must set up a new 2FA method immediately.</li> <li><strong>New codes</strong> - Your old list of recovery codes will be invalidated, so be sure to save a fresh list once your new 2FA is active.</li></ol></section>",
                "12": "<section><p>Please be advised that the FMx platform experienced a service interruption from <strong>2026-04-18 15:04 UTC</strong> through <strong>2026-04-20 05:00 UTC</strong>.</p></section> <section><h3>Technical root cause</h3></section> <section><p>The incident originated from an AWS server degradation and subsequent shutdown. While our autoscale system correctly identified the failure and created a new VM, a misconfiguration during the automated setup of the new server prevented FMx devices from connecting to FOTA WEB.</p></section> <section><h3>Resolution</h3></section> <section><p>The configuration error was identified and corrected. As of <strong>2026-04-20 05:00 UTC</strong>, all services are fully operational and device connectivity has been restored.</p></section> <section><h3>Future prevention</h3></section> <section><p>We take this disruption seriously and are currently conducting a full post-mortem analysis of the event. We are committed to improving our automated deployment and validation processes to ensure that similar configuration issues are caught and prevented in the future.</p></section>",
                "13": "<section><p>Please be advised that we are updating our API endpoints for device group management to improve system performance and minimize operational risks. Starting <strong>June 30, 2026</strong>, the <code>company_id</code> parameter will be completely removed from the group update endpoints (<code>PUT</code> and <code>PATCH</code> <code>/groups/{groupId}</code>).</p></section> <section><h3>What is changing?</h3></section> <section><p>To ensure smoother background processing and a more robust user experience, group movement has been completely separated from standard group updates:</p> <ul><li><strong>UI changes</strong> - In the FOTA WEB interface, moving a device group to another company is no longer handled by editing the group. Instead, it has been moved to a dedicated, background-processed <strong>\"Move\"</strong> button on the \"Device groups\" page.</li> <li><strong>API changes</strong> - The ability to change a company via the group update endpoints has been deprecated. Moving forward, this parameter will be entirely removed from <code>PUT/PATCH /groups/{groupId}</code>.</li></ul></section> <section><h3>What action should you take?</h3></section> <section><p>We recommend the following adjustments for future workflows:</p> <ol><li><strong>Adopt the new endpoint for group moves</strong> - If you need to move a device group to another company via the API, you must switch to the new dedicated endpoint: <code>POST /groups/{groupId}/move</code>.</li> <li><strong>Review API integration scripts</strong> - Ensure that any older, unsubmitted, or hardcoded development scripts do not include the <code>company_id</code> parameter in <code>PUT</code> or <code>PATCH</code> requests for groups before June 30, 2026.</li></ol></section>"
            },
            "title": {
                "1": "Mandatory 2FA for new users starting January 7, 2025",
                "2": "Planned maintenance on June 3, 2025",
                "3": "New Feature Update: Easier Device Unlocking for All Users",
                "4": "Discover What's New on Your Dashboard!",
                "5": "Important: Upcoming API Changes and Sneak Peek at Roles and Permissions",
                "6": "New Feature Available Now: Enhanced Control with \"Roles and Permissions\"",
                "7": "New Feature: More Flexibility with Task Schedule by Date",
                "8": "Security Update: Full Lifecycle Control for User Access",
                "9": "Feature Update: Unified Smart Device Groups for FT and FMx Platforms",
                "10": "Upcoming Change: New Sender Address for FOTA WEB Emails",
                "11": "Security Update: Strengthening Your 2FA Defense",
                "12": "Incident Information: FOTA WEB Connectivity Outage",
                "13": "Upcoming API Change: Deprecation of Company ID in Device Group Endpoints"
            }
        },
        "published": "Published on",
        "take me there": "Take me there",
        "tasks": {
            "current": "Current",
            "status": {
                "completed": "Completed",
                "completed_with_errors": "Completed with errors",
                "failed": "Failed",
                "no tasks": "No tasks"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7 days",
                "tooltipTitle": "Last 7 days"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30 days",
                "tooltipTitle": "Last 30 days"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90 days",
                "tooltipTitle": "Last 90 days"
            }
        },
        "title": {
            "activated": "Activated devices",
            "configurations": "Configurations",
            "device status": "Device status",
            "firmware versions": "Firmware versions",
            "imported": "Imported devices",
            "news": "News",
            "queued tasks": "Queued tasks",
            "refreshed every hour": "refreshed every hour",
            "resource limits": "Resource limits",
            "task overview": "Task overview",
            "tasks": "Tasks"
        },
        "tooltips": {
            "activated": "The number of devices that connected to FOTA WEB for the first time during the selected period (Today, Last 7 Days, Last 30 Days, Last 90 Days).",
            "configurations": "Shows the distribution of configuration file names that have been uploaded to your devices. Up to 100 unique file names are shown.",
            "firmware versions": "Displays the distribution of firmware versions reported by your connected devices. Up to 100 unique versions are shown.",
            "imported": "The number of devices added to your account during the selected period (Today, Last 7 Days, Last 30 Days, Last 90 Days)."
        }
    },
    "Date picker": {
        "disableFuture": "Invalid date",
        "disablePast": "Invalid date",
        "invalidDate": "Invalid date",
        "maxDate": "Wrong date",
        "minDate": "Wrong date",
        "shouldDisableDate": "Invalid date",
        "shouldDisableMonth": "Invalid date",
        "shouldDisableYear": "Invalid date"
    },
    "Device export": {
        "properties": {
            "activity_status": "Status",
            "bootloader": "Bootloader",
            "company_name": "Company",
            "created_at": "Created at",
            "current_configuration": "Configuration",
            "current_firmware": "Firmware",
            "description": "Description",
            "group_name": "Group",
            "gsm_number": "GSM number",
            "iccid": "ICCID",
            "imei": "IMEI",
            "imsi": "IMSI",
            "model": "Model",
            "model_platform": "Platform",
            "modem_version": "Modem version",
            "oem_file_vehicle_name": "OEM file vehicle",
            "product_code": "Product code",
            "seen_at": "Seen at",
            "serial": "Serial No.",
            "task_queue": "Queue",
            "updated_at": "Updated at",
            "vin": "VIN"
        },
        "select data": "Select data"
    },
    "Dialog": {
        "access group inheritance": "User will inherit access group depending on a selected company.",
        "add new device": "Add new device",
        "add new device description": "Add single or multiple new devices to the selected company and group. Only legacy devices, such as FM or FMA, must be imported by marking the \"Import as legacy devices\" checkbox.",
        "add new device legacy title": "Import as legacy devices.",
        "add new device legacy description": "Set \"Created at\" to 2016.01.01 and \"Model\" to Legacy.",
        "add new product code": "Add new product code",
        "add new product code description": "Add a new device product code and link it to available CAN package.",
        "all permissions": "All permissions",
        "assign access group": "Assign access group",
        "assign can package description": "Choose a package type and assign it to all selected devices.",
        "assign role": "Assign role",
        "attribute value": "Attribute value",
        "auto sync": "Auto-Sync",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "Compatible model devices",
                "selected devices": "Selected devices"
            },
            "descriptions": {
                "dialog": "Select an Auto-Sync mode for each supported configuration type. The selected mode will apply to all devices.",
                "Disabled": "Configuration synchronization is disabled.",
                "Enabled": "Detects changes and synchronizes configuration.",
                "ReportingOnly": "Detects/registers configuration changes, but doesn't download configuration."
            },
            "modes": {
                "Disabled": "Off",
                "Enabled": "Sync",
                "ReportingOnly": "Monitor"
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "A .csv list of Bluetooth Beacon IDs for driver authorization.",
                "disabled submit": "Auto-Sync mode cannot be changed for incompatible model devices.",
                "main_configuration_sync": "The main configuration of device with all parameter IDs and values.",
                "manual_geofence_list_sync": "A .csv list of manual geofence zones with coordinates and settings.",
                "one_wire_auth_list_sync": "A .csv list of 1-Wire (iButton/RFID) IDs for driver authorization."
            }
        },
        "begin download": "Begin download",
        "by date": "By date",
        "by time": "By time",
        "can adapter": "CAN adapter",
        "cancel pending tasks": "Cancel pending tasks of the same task type",
        "cancel tasks": "Cancel tasks",
        "cancel tasks in group": {
            "alert title": "This action will take up to several minutes to complete.",
            "banner description": "In order to see the updated status of tasks, please refer to the task group details or refresh the page.",
            "banner title": "This action will take up to several minutes to complete, depending on the number of tasks.",
            "description": "Clicking \"Accept\" will cancel all pending and running tasks. Are you sure you want to proceed?",
            "title": "Cancel all tasks in the group?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "When devices are moved from a selected client/virtual company to another client/virtual company (different hierarchy), their history and tasks are deleted automatically. Use the checkbox below if it's required to delete tasks and history when moving devices in the same hierarchy.",
        "client email": "Client representative email",
        "companies": "Companies",
        "company": "Company",
        "company level": {
            "Basic": "Basic",
            "Internal": "Internal",
            "Premium": "Premium",
            "Standard": "Standard"
        },
        "company level change description": "Upgrade a company level by selecting the new level and providing an explanation why. Downgrading a company level is not possible. All dates are in UTC.",
        "company level manual revert": {
            "confirmation": {
                "description": "This action will set the company level back to the automatically assigned level \"{{companyLevel}}\". Are you sure you wish to continue?",
                "title": "Revert manual level change?"
            },
            "description": "Reverting will change the company level back to its automatically assigned level.",
            "title": "This company level was upgraded manually until {{expirationDate}}."
        },
        "company level type": "Company level type",
        "company name": "Company name",
        "company statistics": {
            "child companies": "Child companies count",
            "devices": "Devices count",
            "files": "Files count",
            "groups": "Device groups count",
            "tasks": "Tasks count",
            "users": "Users count"
        },
        "company type": {
            "All": "All",
            "Client": "Client",
            "Internal": "Internal",
            "Virtual": "Virtual"
        },
        "configuration": "Configuration",
        "confirmations": {
            "are you sure": "Are you sure?",
            "are you sure you wish to continue": "Are you sure you wish to continue?",
            "assign can package confirmation": "Are you sure you want to assign the selected package to the specified number of devices?",
            "cancel task confirmation": {
                "first part": "Are you sure you want to cancel specified number of tasks?",
                "second part": "If so, enter the number of affected tasks and click \"Confirm\"."
            },
            "create task confirmation": "Are you sure you want to create a task for the specified number of devices?",
            "delete resource confirmation": {
                "first part": "Are you sure you want to delete specified number of {{resource}}?",
                "second part": "If so, enter the number of affected {{resource}} and click \"Delete\"."
            },
            "delete resources": {
                "companies": "companies",
                "files": "files",
                "groups": "device groups",
                "deviceModels": "models",
                "productCodes": "product codes",
                "roles": "roles",
                "users": "users"
            },
            "description second part": "If so, enter the number of affected devices and click \"Confirm\".",
            "export device data confirmation": "Are you sure you want to export device data for the specified number of devices?",
            "file": "Enter the number of lines, existing in the file",
            "filter": {
                "companies": "Enter the number of filtered companies",
                "devices": "Enter the number of filtered devices",
                "files": "Enter the number of filtered files",
                "groups": "Enter the number of filtered device groups",
                "productCodes": "Enter the number of filtered product codes",
                "tasks": "Enter the number of filtered tasks",
                "users": "Enter the number of filtered users"
            },
            "id_list": {
                "companies": "Enter the number of selected companies",
                "devices": "Enter the number of selected devices",
                "files": "Enter the number of selected files",
                "groups": "Enter the number of selected device groups",
                "productCodes": "Enter the number of selected product codes",
                "tasks": "Enter the number of selected tasks",
                "users": "Enter the number of selected users"
            },
            "merge companies confirmation": "You're about to merge {{sourceCompany}} and {{targetCompany}} companies.",
            "move companies confirmation": "You're about to move {{sourceCompany}} to {{targetCompany}} company.",
            "move devices confirmation": "Are you sure you want to move the specified number of devices to another company?",
            "number of lines": "Number of lines",
            "selected 20 or more devices": "You’ve selected 20 or more devices...",
            "transfer devices confirmation": "Are you sure you want to transfer the specified number of devices to another company?"
        },
        "confirm cannot revert": "This action is irreversible.",
        "confirm merge companies": "Are you sure you want to merge these companies?",
        "count": "Count",
        "create company": "Create company",
        "create company description": "Create a new company under the selected parent company.",
        "create desktop license": "Create desktop license",
        "create desktop license description": "Issue a new online FOTA desktop license for the client company with their IP, hardware key, and expiration (max 2 years).",
        "create group": "Create group",
        "create group description": "Organize devices into groups for simplified management and bulk assignment.",
        "create model": "Create model",
        "create model description": "Create a new device model specifying name, platform, and TCT web support.",
        "create offline license": "Create offline license",
        "create or edit group description": "Firmware and configuration can be assigned to the group. Once this is done Firmware and/or Configuration update tasks will be generated for all group members (devices).",
        "create role": "Create role",
        "create role description": "Create a new role by giving it a name and description, selecting a company, and assigning specific permissions.",
        "create smart group": "Create Smart Group",
        "create smart group banner message": "Changing files will cancel all previous pending tasks of the same type.",
        "create smart group description": "Firmware and configuration files can be assigned to the group for each platform. Once files are assigned, update tasks will be generated for all group devices.",
        "create task description first step": "Create a wide variety of tasks ranging from updating configuration or firmware to receiving logs, configuration, and more from selected or filtered devices. In addition, you can schedule created tasks for your convenience.",
        "create task description last step": "Make sure the below information is correct before creating the task.",
        "current level": "current level",
        "custom resource limits": {
            "at least one limit must be higher": "At least one limit should be higher than the default Premium level value.",
            "configuration files per device": "Configuration files per device",
            "confirmation modal description": "Are you sure you want to change the following resource limits of the company \"{{companyName}}\"?",
            "confirmation modal title": "Change company resource limits?",
            "count": {
                "companies count": "Companies count: {{number}}",
                "configuration files per device count": "Configuration files per device count: {{number}}",
                "tasks per group count": "Tasks per group count: {{number}}",
                "users count": "Users count: {{number}}"
            },
            "explanations": {
                "companies": "The total number of child companies that can be created in the company hierarchy.",
                "configuration files per device": "The number of configuration files that can be stored, 1 device equals 1 configuration file. The minimum guaranteed amount of configuration files is 100 for each company level.",
                "tasks per group": "The number of tasks that can be in one task group.",
                "users": "The total number of users that can be created in the company hierarchy."
            },
            "main modal description": "Set a custom amount of resources for different resource types like companies, users, tasks per task group, or configuration files. Custom resources will be active until Premium level expiration or manual reset.",
            "resources limit type": "Resources limit type",
            "revert custom resource limits": "Revert custom resource limits",
            "revert custom resource limits description": "Resetting all limits will set it to default resource values and change the company level to Premium.",
            "revert custom resource limits description confirmation": "This action will revert resource limits back to the automatically assigned ones for \"Premium\" level. Are you sure you wish to continue?",
            "revert custom resource limits title": "This company's resource limits were set manually.",
            "revert custom resource limits title confirmation": "Revert custom resource limits?",
            "tasks per group": "Tasks per group"
        },
        "date range": "Date range",
        "date to": "to",
        "delete companies": "Delete companies",
        "delete deviceModels": "Delete models",
        "delete files": "Delete files",
        "delete file warning": "Deleting files will cancel related tasks and task groups.",
        "delete groups": "Delete device groups",
        "delete productCodes": "Delete product codes",
        "delete roles": "Delete roles",
        "delete tasks and history": "Delete tasks and history on company change",
        "delete users": "Delete users",
        "description": "Description",
        "desktop license delete description": "Are you sure you want to delete the desktop license \"{{name}}\"?",
        "desktop license name": "Desktop license name",
        "device identifier": "Device identifier",
        "device transfer": {
            "main": {
                "description": "Transfer selected or filtered devices to an unrelated company using a generated token by the receiving company.",
                "title": "Device transfer"
            },
            "receive devices": {
                "copy token": "Copy and send generated token to the person responsible for transferring devices from their company to yours.",
                "description": "Create receive devices token and send it to the transfer company.",
                "token info": "The token is single-use and expires after 21 days."
            },
            "transfer devices": {
                "confirmation": "Are you sure you want to transfer devices to a company below?",
                "device token": "The device transfer token must be obtained from the manager of the company you wish to transfer your devices to.",
                "transfer from file": "Upload a file with list of devices (IMEIs) you want to transfer from your company to the company whose token you just entered."
            }
        },
        "device transfer token": "Device transfer token",
        "downgrading company level is not possible": "Downgrading a company level is not possible",
        "download sample file message": "Download a <1>sample CSV template</1> to see an example of the required format.",
        "edit group banner message": "Changing firmware and/or configuration files will cancel all previous pending tasks of the same type.",
        "edit group description": "Modify settings for this device group.",
        "edit role description": "Customize role's name, description, and permissions. The assigned company cannot be changed.",
        "edit smart group description": "Firmware and configuration files can be assigned or changed to the group for each platform. Once files are assigned or changed, update tasks will be generated for all group devices.",
        "email": "Email",
        "enter": "Enter",
        "enter code": "Enter code",
        "enter description": "Enter description",
        "enter name": "Enter name",
        "example": "E.g.:",
        "expires at": "Expires at",
        "explanation": "Explanation",
        "export device data": "Export device data",
        "export device description": "Export data for selected or filtered devices to a .csv or .xlsx file format.",
        "export file format": "Export file format",
        "feature": "Feature",
        "feature control": "Feature control",
        "field disabled until company selected": "This field is disabled until the Company is selected.",
        "firmware": "Firmware",
        "files to download": "Files to download",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "The uploaded 1-Wire authorization list will be automatically sorted to improve the speed and accuracy of functionality.",
                "bluetooth_authorization_list": "The uploaded Bluetooth authorization list will be automatically sorted to improve the speed and accuracy of functionality."
            },
            "endings": {
                "file": "file",
                "files": "files"
            },
            "fail": {
                "multiple": "{{failCount}} out of {{totalCount}} {{fileEnding}} were not uploaded due to an error.",
                "single": "{{failCount}} out of {{totalCount}} {{fileEnding}} was not uploaded due to an error."
            },
            "success": {
                "multiple": "All files have been added successfully to the selected companies.",
                "single": "All files have been added successfully to the selected company."
            }
        },
        "filtered": "Filtered",
        "filtered companies": "Filtered companies",
        "filtered devices": "Filtered devices",
        "filtered files": "Filtered files",
        "filtered groups": "Filtered groups",
        "filtered tasks": "Filtered tasks",
        "filtered users": "Filtered users",
        "find tool": {
            "device": {
                "error not valid": "IMEI must consist of 15 characters",
                "error subtitle": "Device not found. Please try typing a different IMEI.",
                "error title": "No device found",
                "link": "Go to device",
                "no permission": "You do not have permission to view this device."
            },
            "user": {
                "error not valid": "Invalid email format",
                "error subtitle": "User not found. Please try typing a different user email.",
                "error title": "No user found",
                "link": "Go to user",
                "no permission": "You do not have permission to view this user."
            }
        },
        "firmware date": "Firmware date",
        "from form": "From form",
        "from file": "From file",
        "general": "General",
        "gsm_number": "GSM number",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "IMEI restriction",
        "import device data": "Import device data",
        "import device data description": "Import selected attribute data for the devices in the provided list.",
        "import device data info": "Each attribute has a maximum character limit displayed in parentheses. If an attribute has more characters than the maximum limit, it will be automatically shortened to the maximum limit.",
        "import device data limit": "(max {{limit}} characters)",
        "imsi": "IMSI",
        "input text too long": "Text is too long. Max {{maxLength}} characters allowed.",
        "invalid hardware key": "Invalid hardware key format",
        "invalid imei": "IMEI is not valid",
        "invalid ipv4": "Invalid IPv4 format",
        "invalid serial": "Invalid serial number",
        "invalid value": "Invalid value",
        "inverted selection": "Inverted selection",
        "invite user": "Invite user",
        "invite user description": "Invite a new user to the selected parent company and set their role. After sending, the user will have 30 days to accept the invitation before it expires.",
        "invite user max roles": "A maximum of 5 roles allowed. Deselect one to proceed.",
        "log files": "Log files",
        "make": "Make",
        "manage permissions": "Manage all account and site-level data.",
        "maximum value is": "Maximum value is {{value}}",
        "merge companies": "Merge companies",
        "merge companies info": "All source company resources (Devices, Groups, Files, Companies, Users with their Roles) will be moved to the target company. You may want to review user roles before merging. Source company will be deleted afterwards.",
        "merge companies disabled option": {
            "client to internal": "Client type company cannot be merged into internal type company.",
            "internal": "Internal type company cannot be merged.",
            "lz code": "Company with Code cannot be merged."
        },
        "minimum value is": "Minimum value is {{value}}",
        "move companies disabled option": {
            "internal": "Internal type company cannot be moved."
        },
        "move device": "Move device",
        "move device description": "Move selected or filtered devices to the existing company and/or group in the company hierarchy.",
        "move device group": "Move device group",
        "move device group banner": "Moving a selected device group to a different company will automatically migrate its associated devices.",
        "move device group description": "Move the selected device group to the selected company.",
        "move devices": "Move devices",
        "name": "Name",
        "newest": "From newest",
        "no dropdown files": {
            "description": "To select this option, upload a new $t(Dialog##no dropdown files##file names##{{fileName}}) file.",
            "description no permission create file": "To select this option, a new $t(Dialog##no dropdown files##file names##{{fileName}}) file must be uploaded, but you need \"$t(General##File.Create)\" permission.",
            "file names": {
                "1_wire_authorization_list": "1-Wire authorization list",
                "adas_firmware": "ADAS firmware",
                "ble_fw": "BLE firmware",
                "blue_nrg": "BlueNrg firmware",
                "bluetooth_authorization_list": "Bluetooth authorization list",
                "can_chip_firmware": "FM CAN Chip firmware",
                "carrier_advance_firmware": "Carrier Advance firmware",
                "carrier_advance_settings": "Carrier Advance settings",
                "carrier_apx_firmware": "Carrier APX firmware",
                "carrier_apx_settings": "Carrier APX settings",
                "certificate": "TLS certificate",
                "configuration": "configuration",
                "dsm_firmware": "DSM firmware",
                "dtb": "DTB",
                "firmware": "firmware",
                "fw_bundle": "firmware bundle",
                "gnssm_download_assistant": "GNSS-M Download Assistant",
                "gnssm_firmware": "GNSS-M firmware",
                "main configuration": "main configuration",
                "manual_geofence_list": "Manual geofence scenario list",
                "meig_modem_firmware": "MeiG modem firmware",
                "netprisma_modem_firmware": "NETPRISMA modem firmware",
                "psub": "subscription",
                "quectel_modem_firmware": "Quectel modem firmware",
                "simcom_modem_firmware": "Simcom Delta modem firmware"
            },
            "main": "There are no $t(Dialog##no dropdown files##file names##{{fileName}}) files."
        },
        "none": "None",
        "obd oem": "OBD OEM",
        "offline license delete description": "Are you sure you want to delete the offline license \"{{name}}\"?",
        "oldest": "From oldest",
        "only integers": "Only integer numbers are valid",
        "only numbers": "Only numbers are valid",
        "optional": "optional",
        "other companies": "Other companies",
        "parent company": "Parent company",
        "permission preset": "Permission preset",
        "platform compatibility": {
            "banner text": "Some of the selected device models are not compatible with the selected task type. This task type will not be created by default for incompatible device models.",
            "compatible model devices": "Compatible model devices",
            "count text": "Task will be created for <1>{{compatibleCount}}</1> out of {{totalCount}} devices.",
            "create tasks for incompatible devices": "Create tasks for incompatible devices.",
            "devices from file": "Devices from file",
            "platform": "{{title}} platform",
            "task applies": "Task applies to",
            "task cannot be created": "Task cannot be created for incompatible model devices."
        },
        "receiving company": "This company will receive your devices",
        "resend user invitation": "Resend user invitation",
        "retry tasks in group": {
            "alert title": "This action will take up to several minutes to complete.",
            "banner description": "In order to see the updated status of tasks, please refer to the task group details or refresh the page.",
            "description": "Pressing \"Accept\" will retry all failed tasks. Are you sure you want to proceed?",
            "title": "Retry all tasks in the group?"
        },
        "revision": "Revision",
        "revision value error": "Value must be two digits (00 - 99).",
        "role name": "Role name",
        "root company": "Root company",
        "sales email": "Sales manager email",
        "scheduled time warning": "Tasks with scheduled time do not change device FOTA connection time configuration. Tasks will be executed if device connects to FOTA during selected time window. Please ensure that devices are configured to connect to FOTA Web at period not less than selected time window.",
        "schedule task": "Schedule task",
        "select": "Select",
        "select at least one": {
            "companies": "Please select at least one company",
            "devices": "Please select at least one device",
            "files": "Please select at least one file",
            "groups": "Please select at least one group",
            "tasks": "Please select at least one task",
            "users": "Please select at least one user"
        },
        "selected": "Selected",
        "selected companies": "Selected companies",
        "selected deviceModels": "Selected models",
        "selected devices": "Selected devices",
        "selected files": "Selected files",
        "selected groups": "Selected device groups",
        "selected productCodes": "Selected product codes",
        "selected roles": "Selected roles",
        "selected tasks": "Selected tasks",
        "selected users": "Selected users",
        "select company": "Select company",
        "select group": "Select group",
        "select time interval": "Select time interval",
        "selected time window": "Selected time window: {{fromDate}} to {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "Bluetooth password",
            "repeat bluetooth password": "Repeat Bluetooth password",
            "enter password": "Enter password",
            "password source": "Password source",
            "rules": {
                "allowed characters": "Letters (a-z, A-Z), digits (0-9), special characters ({{specialSymbols}})",
                "characters length": "Between 8 and 32 characters",
                "passwords must match": "Passwords must match"
            },
            "SystemGenerated": {
                "description": "The system will generate unique, secure password for each device"
            },
            "UserEntered": {
                "description": "Enter a password to apply to the device(s)"
            }
        },
        "show files for selected companies only": "Show files for selected companies only",
        "smart group": {
            "description": "Select available files for {{platformName}} platform devices.",
            "title": "{{platformName}} platform files"
        },
        "sn": "Serial No.",
        "specific": "Specific",
        "time period": "Time period",
        "time period custom": "Custom",
        "tls certificate transfer info": "<strong>FMx platform</strong> communication channel security is not compatible with TLS secure certificate transfer requirements. Use with caution. <strong>FT platform</strong> devices are fully compatible and support secure transfer.",
        "token has expired": "Token has expired",
        "token is valid": "Token is valid",
        "transfer companies": "Transfer companies",
        "transfer companies description": "Select whether to move or merge two companies. Some options are irreversible.",
        "transfer devices": "Transfer devices",
        "tri source": {
            "selected tab description": {
                "create task": "The chosen task will be created for selected devices using the checkbox.",
                "general": "The chosen action will be executed for selected devices using the checkbox."
            },
            "filtered tab description": {
                "create task": "The chosen task will be created for filtered devices using one or more available filters.",
                "general": "The chosen action will be executed for filtered devices using one or more available filters."
            },
            "from file tab description": {
                "create task": "The chosen task will be created for devices that were specified in the uploaded file.",
                "general": "The chosen action will be executed for devices that were specified in the uploaded file."
            }
        },
        "unlocker": {
            "generate unlock key": "Generate unlock key",
            "generate unlock key description": "Enter the device \"Lock code\" from TCT in the field below. Press the \"Generate\" button to generate an unlock key, and use it in TCT to unlock your device.",
            "invalid lock code": "Invalid device lock code.",
            "limit reached": "You have reached the maximum number of generated unlock keys.",
            "lock code": "Lock code",
            "unlock key": "Unlock key",
            "unlock key success message": "Unlock key successfully generated."
        },
        "upload file": "Upload file",
        "upload file description": "Upload up to {{count}} files at once using the drag-and-drop field or by selecting them.",
        "upload firmware bundle container info": "Please ensure your devices are running firmware <strong>3.7.0-rc.22</strong> or above. This task is not compatible with earlier versions and will result in a failure. For more information, refer to our <a>wiki.</a>",
        "upload firmware downgrade protection info": "The 04.00.00 and above firmware versions include downgrade protection. For more details on firmware changes, please review our documentation at <1>Teltonika GPS Wiki</1>. By pressing the \"Next\" button you agree and understand above information.",
        "upload firmware unsupported info": "Update to this version is not available, please contact Teltonika support or your Teltonika sales manager.",
        "use at least one filter": "Please use at least one filter",
        "user": "User",
        "valid until": "Valid until",
        "valid until date disable description": "This field can only be changed when Time period is set to \"Custom\"",
        "vehicle model": "Model"
    },
    "Dropzone": {
        "add file": "Add file",
        "add files": "Add files",
        "drop file to upload": "Drop the file to upload",
        "drop files to upload": "Drop files to upload",
        "error uploading the file": "There was an error uploading the file",
        "file invalid type": "Invalid file type selected.",
        "file successfully uploaded": "File successfully uploaded",
        "file syntax": "File syntax is as follows:",
        "invalid format or size": "Invalid format or file size exceeds {{size}}.",
        "max file size": "Maximum file size {{size}}",
        "maximum file limit reached": "The maximum file limit reached.",
        "only one file can be attached": "Only one file can be attached.",
        "or drop file to upload": "Or drop file to upload",
        "or drop files to upload": "Or drop files to upload",
        "rows detected": "Rows in the file successfully detected",
        "select file": "Select file",
        "select files": "Select files",
        "select file type": "Please select the file type first.",
        "supported formats": "Supported formats",
        "too long file name": "File name is too long. Max {{maxLength}} characters allowed.",
        "too many files description": "The rest of the files can be uploaded after you upload the selected files.",
        "too many files title": "There is a maximum file limit of {{maxFiles}} you can attach at once."
    },
    "Error": {
        "error": "Error",
        "message wait": "Brace yourself till we get the error fixed.",
        "title": "Something went wrong!"
    },
    "Feature highlight": {
        "got it": "Got it",
        "new feature": "New feature!",
        "scenarios description": "Now, you can set one of the following scenarios on your device: Overspeeding, Crash Detection, or Towing Detection."
    },
    "Filter": {
        "access group": "Access group",
        "activity_status": "Status",
        "all permissions": "All permissions",
        "batch_id": "Batch ID",
        "company_id": "Company",
        "company selector": "Company selector",
        "configuration change origin": "Change origin",
        "configuration_file_id": "FMx configuration",
        "configuration type": "Configuration type",
        "created_by": "Created by",
        "current_configuration": "Configuration",
        "current_firmware": "Firmware",
        "device_imei": "Device IMEI",
        "file type": "File type",
        "filtered by": "Filtered by",
        "filters used": "Filters used",
        "firmware_file_id": "FMx firmware",
        "ft_bluetooth_auth_list_file_id": "FT Bluetooth authorization list",
        "ft_configuration_file_id": "FT main configuration",
        "ft_firmware_file_id": "FT firmware",
        "ft_one_wire_auth_list_file_id": "FT 1-Wire authorization list",
        "group_id": "Group",
        "id": "ID",
        "Invalid company": "Invalid company",
        "model": "Model",
        "model_platform": "Platform",
        "Multiple companies": "Multiple companies",
        "parent company": "Parent company",
        "permission": "Permission",
        "permission status": "Status",
        "role": "Role",
        "spec_id": "Spec ID",
        "status_id": "Status",
        "supported_task_type": "Task type",
        "table filters": "Table filters",
        "task type": "Task type",
        "task_queue": "Queue",
        "type": "Type",
        "user status": "Status"
    },
    "Flash": {
        "account was deleted": "Your account has been deleted",
        "ADAS firmware file size can't be zero": "ADAS firmware file size can't be zero.",
        "ADAS firmware is invalid.": "ADAS firmware is invalid.",
        "All notifications were deleted.": "All notifications were deleted.",
        "All notifications were marked as read.": "All notifications were marked as read.",
        "At least one user role must be provided.": "At least one user role must be provided.",
        "Attributes length is invalid": "Attributes length is invalid.",
        "Banner was updated.": "Banner was updated.",
        "Batch was discarded": "Batch was discarded.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "Bulk attribute update job was created. Devices' attributes will be updated shortly.",
        "Bulk create job was created. Devices will be created shortly.": "Bulk create job was created. Devices will be created shortly.",
        "Bulk create job was created. Tasks will be created shortly.": "Bulk create job was created. Tasks will be created shortly.",
        "Bulk delete job was created. Companies will be removed shortly.": "Bulk delete job was created. Companies will be removed shortly.",
        "Bulk delete job was created. Devices will be removed shortly.": "Bulk delete job was created. Devices will be removed shortly.",
        "Bulk delete job was created. Files will be removed shortly.": "Bulk delete job was created. Files will be removed shortly.",
        "Bulk delete job was created. Groups will be removed shortly.": "Bulk delete job was created. Groups will be removed shortly.",
        "Bulk delete job was created. Product codes will be removed shortly.": "Bulk delete job was created. Product codes will be removed shortly.",
        "Bulk delete job was created. Users will be removed shortly.": "Bulk delete job was created. Users will be removed shortly.",
        "Bulk task create job was created. Tasks will be created shortly.": "Bulk task job was created and tasks will appear shortly. Tasks can be found on the \"Task groups\" page under Task group details.",
        "Bulk update job was created. Devices will be updated shortly.": "Bulk update job was created. Devices will be updated shortly.",
        "Bulk update job was created. Tasks will be updated shortly.": "Bulk update job was created. Tasks will be updated shortly.",
        "Can adapter was added.": "CAN adapter was added.",
        "Can adapter was deleted.": "CAN adapter was deleted.",
        "Can adapter was updated.": "CAN adapter was updated.",
        "Can chip firmware file size can't be zero": "CAN chip firmware file size can't be zero.",
        "Can chip firmware is invalid.": "CAN chip firmware is invalid.",
        "Cannot delete company. Company is not empty.": "Cannot delete company. Company is not empty.",
        "Cannot delete file. It is used by pending or running tasks.": "Cannot delete file. It is used for pending or running tasks.",
        "Cannot delete file. It is used by running tasks.": "Cannot delete file. It is used by running tasks.",
        "Cannot delete file. There are tasks waiting for approval.": "Cannot delete file. There are tasks waiting for approval.",
        "Cannot delete product code assigned to devices.": "Cannot delete product code assigned to devices.",
        "check your email for details": "Check your email for more details.",
        "Companies count limit exceeded.": "Companies count limit exceeded.",
        "Companies in the request must belong to the selected root.": "Companies in the request must belong to the selected root.",
        "Company merge job was created. It will be merged shortly.": "Company merge job was created. It will be merged shortly.",
        "Company name already exist.": "Company name already exists.",
        "Company level change is not allowed.": "Company level change is not allowed.",
        "Company level successfully changed": "Company level successfully changed.",
        "company level successfully reverted": "Company level successfully reverted back to automatically assigned level.",
        "Company not allowed to be merged": "Company not allowed to be merged.",
        "company resource limits changed": "Company resource limits successfully changed.",
        "Company was created.": "Company was created.",
        "Company was deleted.": "Company was deleted.",
        "Company was updated.": "Company was updated.",
        "compatibilities added": "{{count}} new compatibility(ies) added during synchronization.",
        "compatibilities synchronized": "Successfully synchronized missing compatibilities.",
        "Configuration cannot have FOTA functionality disabled": "Configuration cannot have FOTA functionality disabled.",
        "Configuration file cannot contain duplicate parameters": "Configuration file cannot contain duplicate parameters.",
        "Configuration file size can't be zero": "Configuration file size cannot be zero.",
        "Configuration files count limit exceeded.": "Configuration files count limit exceeded.",
        "Configuration version must be defined": "Configuration version must be defined.",
        "custom resource limits successfully reverted": "Custom resource limits successfully reverted back to automatically assigned limits.",
        "Custom roles feature is not enabled.": "Custom roles feature can only be used by users with Premium company level. Previously created custom roles can be deleted.",
        "desktop license added": "Desktop license \"{{name}}\" was successfully added.",
        "Devices already are in target company": "Devices already are in target company.",
        "Device already exists.": "Device already exists.",
        "Device bulk attribute update file cannot be empty": "Device bulk attribute update file cannot be empty.",
        "Device bulk attribute update file should be .csv": "Device bulk attribute update file should be .csv.",
        "Device export limit reached. You can not export more than 100000 devices": "Device export limit reached. You cannot export more than 100,000 devices.",
        "Device import limit reached. You can not import more than 100 devices": "Device import limit reached. You cannot import more than 100 devices.",
        "Device model and task type compatibility was updated.": "Device model and task type compatibility was updated.",
        "Device model was created.": "Device model was created.",
        "Device model was deleted.": "Device model was deleted.",
        "Device model was updated.": "Device model was updated.",
        "Device not found": "Device not found.",
        "Device Transfer job was created. Devices will be transfered shortly.": "Device Transfer job was created. Devices will be transfered shortly.",
        "Device was added.": "Device was added.",
        "Device was deleted.": "Device was deleted.",
        "Device was updated.": "Device was updated.",
        "Email or password is incorrect.": "The email or password you entered is incorrect.",
        "Failed to create Product code": "Failed to create product code.",
        "Failed to delete Product code": "Failed to delete product code.",
        "Failed to import devices.": "Failed to import devices.",
        "Failed to Read Product code": "Failed to read product code.",
        "Failed to retry failed tasks": "Failed to retry failed tasks.",
        "Failed to update Product code": "Failed to update product code.",
        "Failed to update task for retry": "Failed to retry failed task.",
        "Field is not valid": "Field is not valid.",
        "File description is too long. Max 255 characters allowed.": "File description is too long. Max 255 characters allowed.",
        "File exceeds entries limit of 10000.": "The file exceeds the entry limit of 10,000.",
        "File must not contain duplicated IMEIs": "File must not contain duplicated IMEIs.",
        "File must not contain IMEIs that already exist in database.": "File must not contain IMEIs that already exist in database.",
        "File must not contain invalid IMEIs": "File must not contain invalid IMEIs.",
        "File name is too long. Max 255 characters allowed.": "File name is too long. Max 255 characters allowed.",
        "File name should not contain illegal characters or symbols": "File name cannot contain any special characters.",
        "File not found": "File not found.",
        "File was deleted.": "File was deleted.",
        "File was successfully uploaded.": "File was successfully uploaded.",
        "File was updated.": "File was updated.",
        "File was uploaded. Devices will be imported shortly.": "File was uploaded. Devices will be imported shortly.",
        "File will be created shortly. Check files in a second.": "File will be created shortly. Check files in a second.",
        "Firmware already exists in global files.": "Firmware already exists in global files.",
        "Firmware bundle already exists in global files.": "Firmware bundle already exists in global files.",
        "Firmware file size can't be zero": "Firmware file size can't be zero.",
        "First device in file not found.": "First device in file not found.",
        "Forbidden": "Forbidden.",
        "Group name already exist.": "Group name already exists.",
        "Group was added.": "\"'{{group}}'\" successfully created.",
        "Group was created.": "Group was created.",
        "Group was deleted.": "Group was deleted.",
        "Group was updated.": "Group was updated.",
        "Invalid device bulk update attribute": "Invalid device bulk update attribute.",
        "Invalid email address.": "Invalid email address.",
        "Invalid file contents": "Invalid file contents.",
        "Invalid file name": "Invalid file name.",
        "Invalid invitation token.": "Invalid invitation token.",
        "Invalid token": "Invalid token.",
        "Invalid token length": "Invalid token length.",
        "Internal Server Error": "Internal Server Error.",
        "Internal users must sign in using Microsoft Entra ID.": "Internal users must sign in using Microsoft Entra ID.",
        "License was deleted.": "License was deleted.",
        "License was updated.": "License was updated.",
        "Maximum companies hierarchy depth exceeded": "Maximum companies hierarchy depth exceeded",
        "Maximum device group size exceeded.": "Maximum device group size exceeded.",
        "Method Not Allowed": "Method Not Allowed.",
        "Network Error": "Network Error.",
        "No changes made": "No changes were made.",
        "No resources found.": "No resources found.",
        "not allowed to affect batch": {
            "description": "Please make sure you are controlling the company of user that created this task group.",
            "title": {
                "approve": "You do not have permission to approve this batch.",
                "discard": "You do not have permission to discard this batch."
            }
        },
        "Not Found": "Not found.",
        "Notification was deleted.": "Notification was deleted.",
        "notify when done title": "This might take a while. Press the button below to close this screen and you will get a notification when done.",
        "Obd record was created.": "OBD record was created.",
        "Obd record was updated.": "OBD record was updated.",
        "offline license added": "Offline license \"{{name}}\" was successfully added.",
        "Offline license was deleted.": "Offline license was deleted.",
        "Only id_list source is supported.": "Only id_list source is supported.",
        "Only users with Teltonika email can be invited into internal companies.": "Only users with Teltonika email can be invited into internal companies.",
        "Only users with Teltonika email can be moved into internal companies.": "Only users with Teltonika email can be moved into internal companies.",
        "Parent company cannot be a descendant of the updated company.": "Parent company cannot be a descendant of the updated company.",
        "Password reset link was sent to Your email.": "Password reset link was sent to Your email.",
        "Password reset token is invalid, expired or related user no longer exists.": "Password reset token is invalid, expired or the user no longer exists.",
        "Password was changed.": "Password was changed.",
        "product code added": "Product code \"{{code}}\" was successfully added.",
        "Product code is too long. Max 200 characters allowed.": "Product code is too long. Max 200 characters allowed.",
        "ProductCode already exists.": "Product code already exists.",
        "ProductCode not found": "Product code not found.",
        "Product code was deleted.": "Product code was deleted.",
        "Product code was updated.": "Product code was updated.",
        "Retry failed tasks job was created": "Retry failed tasks job was created.",
        "Role cannot be set for an internal user.": "Role cannot be set for an internal user.",
        "Role was created.": "Role was created.",
        "Role was deleted.": "Role was deleted.",
        "Role was updated.": "Role was updated.",
        "selected company changed": "The selected company was changed.",
        "Selected firmware bundle is not supported by the device.": "Selected firmware bundle is not supported by the device.",
        "Server Error": "Server Error.",
        "signalr connection failed": "SignalR connection failed.",
        "signalr join groups failed": "SignalR failed to join groups.",
        "SMS was sent.": "SMS was sent.",
        "Something went wrong while saving a new password.": "Something went wrong while saving a new password.",
        "Successfully logged out.": "Successfully logged out.",
        "System Admin user level is required in order to perform this action.": "System Admin user level is required in order to perform this action.",
        "Target company cannot be a descendant of source company.": "Target company cannot be a descendant of source company.",
        "Task create limit exceeded.": "You cannot create a task group for more than 100,000 devices.",
        "Task type is not retriable": "Task type is not retriable",
        "Task was added.": "Task was added.",
        "task was created": "The task was created for {{imei}} (\"{{taskType}}\"). The task can be found on the \"Devices\" page under \"Tasks\" of device details.",
        "Task was updated.": "Task was updated.",
        "Tasks were approved": "Tasks were approved.",
        "The given data was invalid.": "The given data was invalid.",
        "time zone changed": "The time zone has been changed.",
        "Token cannot be null or empty": "Token cannot be null or empty.",
        "token created": "API token was successfully created.",
        "Token has expired": "Token has expired.",
        "Token's and token's owner companies do not match": "Token's and token's owner companies do not match.",
        "Token was deleted.": "Token was deleted.",
        "Too many resources in the request": "Too many resources in the request",
        "Too Many Requests": "Too Many Requests.",
        "Transfer token created": "Transfer token created.",
        "tutorial completed": "Tutorial successfully completed",
        "Two factor authentication is already activated for the user.": "Two factor authentication is already activated for the user.",
        "Two factor authentication successfully disabled.": "Two factor authentication successfully disabled.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "Unable to send SMS. This device does not have a GSM number assigned.",
        "Unable to validate Your request.": "Unable to validate Your request.",
        "Unauthenticated.": "Unauthenticated.",
        "Unauthorized": "Unauthorized.",
        "User access level is not valid": "User access level is not valid",
        "User invitation was revoked": "Invitation successfully cancelled.",
        "User invitation was re-sent": "User invitation was re-sent.",
        "User is already in the system.": "User is already in the system.",
        "User was created.": "User was created.",
        "User was deleted.": "User was deleted.",
        "User was invited.": "User invitation successfully sent.",
        "User was updated": "User was updated.",
        "Users count limit exceeded.": "Users count limit exceeded.",
        "Your password has been changed.": "Your password has been changed."
    },
    "General": {
        "0": "User",
        "5": "Support",
        "10": "Admin",
        "15": "Admin Manager",
        "19": "Internal Integration",
        "20": "System User",
        "99": "Super User",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "Company create",
        "Company.Delete": "Company delete",
        "Company.Merge": "Company merge",
        "Company.Update": "Company update",
        "Device.Export": "Device export",
        "Device.Read": "Device read",
        "Device.SecretsRead": "Device secrets",
        "Device.Transfer": "Device transfer",
        "Device.Unlock": "Device unlock",
        "Device.Update": "Device update",
        "DeviceGroup.Create": "Device group create",
        "DeviceGroup.Delete": "Device group delete",
        "DeviceGroup.Read": "Device group read",
        "DeviceGroup.Update": "Device group update",
        "File.Create": "File create",
        "File.Delete": "File delete",
        "File.Download": "File download",
        "File.Read": "File read",
        "File.TctWebAccess": "TCT web",
        "File.Update": "File update",
        "Role.Create": "Role create",
        "Role.Delete": "Role delete",
        "Role.Read": "Role read",
        "Role.Update": "Role update",
        "Task.Create": "Task create",
        "Task.Read": "Task read",
        "Task.Retry": "Task retry",
        "Task.Update": "Task update",
        "TaskGroup.Read": "Task group read",
        "TctIntegration.Access": "TCT integration",
        "Token.Create": "Token create",
        "Token.Delete": "Token delete",
        "Token.Read": "Token read",
        "User.Create": "User create",
        "User.Delete": "User delete",
        "User.Read": "User read",
        "User.Update": "User update",
        "--- END-OF-PERMISSIONS ---": "",
        "1_wire_authorization": "1-Wire authorization",
        "1-wire authorization list": "1-Wire authorization list",
        "1_wire_authorization_list": "1-Wire authorization list",
        "Active": "Active",
        "adas_firmware": "ADAS firmware",
        "apx_firmware": "APX firmware",
        "assign can package": "Assign CAN package",
        "assigned package": "Assigned package",
        "automatic": "Automatic",
        "banner management": "Banner management",
        "batches": "Task groups",
        "black_box": "Black box",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE firmware",
        "blue_nrg": "BlueNRG firmware",
        "bluetooth_authorization": "Bluetooth authorization",
        "BluetoothAuthorizationList": "Bluetooth authorization list",
        "bluetooth authorization list": "Bluetooth authorization list",
        "bluetooth_authorization_list": "Bluetooth authorization list",
        "bluetooth password": "Bluetooth password",
        "boolean filtered value name": {
            "task_support": {
                "false": "Incompatible",
                "true": "Compatible"
            },
            "web_editor_support": {
                "false": "TCT web unsupported",
                "true": "TCT web supported"
            }
        },
        "can": "CAN",
        "can adapter name": "CAN adapter name",
        "can bootstring": "Bootstring",
        "can configuration": "OEM configuration",
        "can_debug_log": "CAN debug log",
        "can oem file package": "OEM file package",
        "can oem file vehicle": "OEM file vehicle",
        "can package": "OEM package",
        "can program number": "CAN program number",
        "can revision": "CAN revision",
        "can software date": "CAN software date",
        "can type": "CAN type",
        "Cancelled": "Cancelled",
        "cancel task": "Cancel task",
        "can_chip_firmware": "FM CAN Chip firmware",
        "carrier_advance_firmware": "Carrier Advance firmware",
        "carrier_advance_settings": "Carrier Advance settings",
        "carrier_apx_firmware": "Carrier APX firmware",
        "carrier_apx_settings": "Carrier APX settings",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "Carrier Temperature Logger files",
        "certificate": "Certificate",
        "click for more details": "Click for more details",
        "client ip": "Client IP",
        "clone model": "Clone device model",
        "collapse menu": "Collapse menu",
        "companies": "Companies",
        "company": "Company",
        "company level": "Company level",
        "company type": "Company type",
        "company name": "Company name",
        "Completed": "Completed",
        "Completed with errors": "Completed with errors",
        "configuration": "Configuration",
        "configuration_36": "Configuration (FM36)",
        "configuration_64": "Configuration (FMB64)",
        "crash_dump": "Crash dump log",
        "created at": "Created at",
        "created by": "Created by",
        "custom": "Custom",
        "custom resource limits": "Custom resource limits",
        "dashboard": "Dashboard",
        "delete desktop license": "Delete desktop license",
        "delete offline license": "Delete offline license",
        "desktopLicenses": "Desktop licenses",
        "device_export_file_csv": "Device export file (.csv)",
        "device_export_file_xlsx": "Device export file (.xlsx)",
        "deviceModels": "Models",
        "deviceModelTaskCompatibilities": "Compatibilities",
        "device_transfer_report": "Device transfer report",
        "device group": "Group",
        "DeviceImportFile": "Device import file",
        "devices": "Devices",
        "download file": "Download file",
        "download offline license": "Download offline license",
        "dsm_firmware": "DSM firmware",
        "dtb": "DTB",
        "edit compatibility": "Edit device compatibility",
        "edit model": "Edit device model",
        "edit company": "Edit company",
        "edit desktop license": "Edit desktop license",
        "edit device": "Edit device",
        "edit file": "Edit file",
        "edit group": "Edit group",
        "edit in tct web": "Edit in TCT web",
        "edit in tct web disabled": "Edit in TCT web is only available for Premium company level.",
        "edit product code": "Edit product code",
        "edit role": "Edit role",
        "edit smart group": "Edit Smart Group",
        "edit user": "Edit user",
        "Empty": "Empty",
        "enter here": "Enter here",
        "exception_info": "Exception info",
        "Executing": "Executing",
        "expand menu": "Expand menu",
        "Expired": "Expired",
        "Factory": "Factory",
        "Failed": "Failed",
        "file": "File",
        "file data": "File data",
        "files": "Files",
        "file deleted": "File was deleted",
        "firmware": "Firmware",
        "firmware_36": "Firmware (FM36)",
        "firmware_64": "Firmware (FMB64)",
        "Fmx": "FMx",
        "Fota": "FOTA WEB",
        "Ft": "FT",
        "fw_bundle": "Firmware bundle",
        "fw_bundle_ble": "Bundle - BLE Firmware",
        "fw_bundle_ble_dtb": "Bundle - BLE DTB",
        "fw_bundle_can": "Bundle - CAN Firmware",
        "fw_bundle_can_dtb": "Bundle - CAN DTB",
        "fw_bundle_dtb": "Bundle - Main DTB",
        "fw_bundle_mainfw": "Bundle - Main firmware",
        "generic": "Generic file",
        "global_configuration": "Global configuration",
        "global_firmware": "Global firmware",
        "gnssm_download_assistant": "GNSS-M Download Assistant",
        "gnssm_firmware": "GNSS-M firmware",
        "group": "Group",
        "groups": "Device groups",
        "hardware key": "Hardware key",
        "id": "ID",
        "id_collection_file": "ID collection file",
        "imei restriction": "IMEI restriction",
        "Inactive": "Inactive",
        "Invalid": "Invalid",
        "invalid model": "Invalid model",
        "invalid model_name": "Invalid model",
        "InvitationExpired": "Expired invitation",
        "InvitationPending": "Pending invitation",
        "Legacy": "Legacy",
        "legacy model": "Legacy model",
        "legacy model_platform": "Legacy platform",
        "legacy platform": "Legacy platform",
        "license has expired": "License has expired",
        "loading": "Loading",
        "log": "Log",
        "MainConfiguration": "Main configuration",
        "main configuration": "Main configuration",
        "manual": "Manual",
        "ManualGeofenceList": "Geofence scenario list",
        "manual geofence list": "Manual geofence scenario list",
        "manual_geofence_list": "Manual geofence scenario list",
        "manual_geofence_scenarios": "Manual geofence scenarios",
        "meig_modem_firmware": "MeiG modem firmware",
        "menu": "Menu",
        "modem version": "Modem version",
        "netprisma_modem_firmware": "NETPRISMA modem firmware",
        "nmea_log": "NMEA log",
        "no": "No",
        "no results": "No initial results found",
        "no results description": "As soon as {{name}} are uploaded to FOTA WEB, you'll be able to see the data here",
        "not assigned": "Not Assigned",
        "not assigned configuration_file_id": "Configuration not assigned",
        "not assigned current_configuration": "Configuration not assigned",
        "not assigned current_firmware": "Firmware not assigned",
        "not assigned firmware_file_id": "Firmware not assigned",
        "not assigned group_id": "Group not assigned",
        "not assigned model": "Model not assigned",
        "not assigned spec_id": "Spec ID not assigned",
        "not assigned task_type": "Task type not assigned",
        "obd_chip_firmware": "FM OBD Chip firmware",
        "obd chip firmware version": "OBD Chip Firmware Version",
        "Offline": "Offline",
        "offline licenses": "Offline licenses",
        "Online": "Online",
        "OneWireAuthorizationList": "1-Wire authorization list",
        "open in tct": "Open in TCT",
        "or": "or",
        "other": "Other",
        "Pending": "Pending",
        "Pending approval": "Waiting for approval",
        "permission disabled": "Disabled",
        "permission enabled": "Enabled",
        "productCodes": "Product codes",
        "psub": "Subscription file",
        "quectel_fw": "Quectel modem firmware (quectel_fw)",
        "quectel_modem_firmware": "Quectel modem firmware",
        "resend invite": "Resend invitation",
        "restricted": "Restricted",
        "retry": "Retry",
        "roles": "Roles and Permissions",
        "Running": "Running",
        "RxAutoscan": "Receive autoscan CAN file",
        "RxBlackBox": "Receive black box",
        "RxBluetoothAuthorizationList": "Receive Bluetooth authorization list",
        "RxCanDebugLog": "Receive CAN debug log",
        "RxCarrierExtractions": "Download Carrier extractions",
        "RxCarrierLoggerFiles": "Download Carrier temperature logger files",
        "RxConfiguration": "Receive configuration",
        "RxCrashDump": "Receive crash dump log",
        "RxExceptionInfo": "Receive exception info",
        "RxLog": "Receive internal log",
        "RxManualGeofenceList": "Receive manual geofence scenario list",
        "RxNmeaLog": "Receive NMEA log",
        "RxOneWireAuthorizationList": "Receive 1-Wire authorization list",
        "RxWdLog": "Receive watch-dog (WD) log",
        "select company": "Select company",
        "SetBindSim": "Bind device with current SIM card(s)",
        "SetBluetoothPassword": "Set Bluetooth password",
        "SetDisableFeature": "Disable feature",
        "SetEnableFeature": "Enable feature",
        "SetForceLockSim": "Force lock SIM",
        "SetUnbindSim": "Unbind device with SIM card(s)",
        "simcom_modem_firmware": "Simcom Delta modem firmware",
        "SmsGprs": "SMS/GPRS",
        "status": "Status",
        "task details": "Task details",
        "task groups": "Task groups",
        "tasks": "Task groups",
        "tasksCompatibility": "Tasks compatibility",
        "task type": "Task type",
        "Tct": "TCT",
        "time zone": "Time zone",
        "total": "Total",
        "tutorials": "Tutorials",
        "TxAdasFirmware": "Upload ADAS firmware",
        "TxAgpsMt3333": "Transfer AGPSM file",
        "TxAgpsQuectelL89": "Transfer AGPSQ file",
        "TxAutoscanCanConfiguration": "Upload autoscan OEM file",
        "TxBleFirmware": "Upload BLE firmware",
        "TxBlueNrgFirmware": "Upload BlueNrg firmware",
        "TxBluetoothAuthorizationList": "Upload Bluetooth authorization list",
        "TxBundleBle": "Upload BLE Firmware",
        "TxBundleBleDtb": "Upload BLE DTB",
        "TxBundleCan": "Upload CAN Firmware",
        "TxBundleCanDtb": "Upload CAN DTB",
        "TxBundleDtb": "Upload Main DTB",
        "TxBundleFirmware": "Upload Main Firmware",
        "TxCanAdapterModeChange": "Change external CAN adapter mode",
        "TxCanAdapterModeChangeInternal": "Change internal CAN adapter mode",
        "TxCanAdapterUpdate": "Upload CAN adapter firmware",
        "TxCanAdapterUpdateInternal": "Update internal CAN adapter",
        "TxCanChipFirmware": "Upload FMXY50 CAN chip firmware",
        "TxCanConfiguration": "Upload OEM file",
        "TxCarrierAdvanceFirmware": "Update Carrier Advance firmware",
        "TxCarrierAdvanceSettings": "Update Carrier Advance settings",
        "TxCarrierApxFirmware": "Update Carrier APX firmware",
        "TxCarrierApxSettings": "Update Carrier APX settings",
        "TxConfiguration": "Upload configuration",
        "TxDsmFirmware": "Upload DSM firmware",
        "TxDtb": "Upload DTB",
        "TxFirmware": "Upload firmware",
        "TxFirmwareBundle": "Upload Firmware Bundle Container",
        "TxFirmwareBundleParts": "Upload Firmware bundle",
        "TxFotaCertificate": "Update FOTA Certificate",
        "TxGenericFile": "Upload generic file",
        "TxGNSSMDownloadAssistant": "Upload GNSS-M Download Assistant",
        "TxGNSSMFirmware": "Upload GNSS-M firmware",
        "TxManualGeofenceList": "Upload manual geofence scenario list",
        "TxMeigModemDeltaFirmware": "Upload MeiG Delta Modem Firmware",
        "TxNetprismaModemDeltaFirmware": "Upload NETPRISMA Delta Modem Firmware",
        "TxObdChipFirmware": "Update OBD chip",
        "TxObdConfig": "Transfer OBD configuration file",
        "TxOneWireAuthorizationList": "Upload 1-Wire authorization list",
        "TxPSub": "Transfer subscription file",
        "TxQuectelModemDeltaFirmware": "Upload Quectel Delta Modem Firmware",
        "TxSimcomModemDeltaFirmware": "Update Simcom Delta Modem Firmware",
        "TxUserCertificate": "Upload user TLS certificate",
        "users": "Users",
        "Unknown": "Unknown",
        "unknown": "Unknown",
        "unknown model_platform": "Unknown platform",
        "unknown origin": "Unknown origin",
        "unknown platform": "Unknown platform",
        "unrestricted": "Unrestricted",
        "Verifying": "Verifying",
        "vin": "VIN",
        "vip status": "VIP status",
        "wd_log": "WD log",
        "yes": "Yes"
    },
    "Maintenance": {
        "title": "Hang on! We are under maintenance."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} failed due to server error.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "You do not have permission to cancel all selected tasks. Some tasks are associated with resources from different companies.",
            "Cancel tasks action failed. No resources found.": "No tasks matched your selection. Please review your task selection and try again.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" ({{TargetCompanyId}}).",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "Company merge failed. Companies \"{{SourceCompanyId}}\" and \"{{TargetCompanyId}}\" cannot be merged due to incompatible settings or permissions.",
            "Create device group tasks action failed. No resources found.": "Failed to create tasks for Smart Group. Please try to reassign the file.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{CreatedTaskCount}} task(s) created for device group ID: {{GroupId}} devices.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "You do not have permission to create tasks for all selected devices. Some devices belong to different companies.",
            "Create tasks action failed. No resources found.": "No devices matched your selection. Please review your device selection and try again.",
            "Create tasks action failed. No resources processed.": "Failed to process selected devices. Please try to create task group again.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "You do not have permission to delete all selected companies. Some companies are not under your direct management.",
            "Delete companies action failed. No resources found.": "No companies matched your selection. Please review your company selection and try again.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "You do not have permission to delete all selected files. Some files are associated with resources from different companies.",
            "Delete files action failed. No resources found.": "No files matched your selection. Please review your file selection and try again.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "You do not have permission to delete all selected device groups. Some device groups contain resources from different companies.",
            "Delete groups action failed. No resources found.": "No device groups matched your selection. Please review your device group selection and try again.",
            "Delete product codes action failed. No resources found.": "No product codes matched your selection. Please review your product code selection and try again.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "You do not have permission to delete all selected users. Some users belong to different companies.",
            "Delete users action failed. No resources found.": "No users matched your selection. Please review your user selection and try again.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "Device group ID: {{GroupId}} move failed. Target company ID: {{TargetCompanyId}} cannot be found.",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "Device group ID: {{GroupId}} successfully moved to company ID: {{TargetCompanyId}}.",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} device(s) exported to \"{{Filename}}\".",
            "{{DevicesCount}} device(s) imported.": "{{DevicesCount}} device(s) imported.",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.",
            "Export devices action failed. No resources found.": "No devices matched your selection. Please review your device selection and try again.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.",
            "Invalid request scope. Resources must belong to single root.": "Invalid request scope. Resources must belong to single root.",
            "Move device group action failed. No resources found.": "No device groups matched your selection. Please review your device group selection and try again.",
            "{{ProcessedCount}} companies deleted.": "{{ProcessedCount}} companies deleted.",
            "{{ProcessedCount}} device group(s) deleted.": "{{ProcessedCount}} device group(s) deleted.",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}} device attribute(s) updated.",
            "{{ProcessedCount}} device model(s) deleted.": "{{ProcessedCount}} device model(s) deleted.",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}} device(s) updated.",
            "{{ProcessedCount}} file(s) deleted.": "{{ProcessedCount}} file(s) deleted.",
            "{{ProcessedCount}} product code(s) deleted.": "{{ProcessedCount}} product code(s) deleted.",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} task(s) cancelled.",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} task(s) updated.",
            "{{ProcessedCount}} user(s) deleted.": "{{ProcessedCount}} user(s) deleted.",
            "Retry tasks action failed. No resources found.": "No tasks matched your selection. Please review your task selection and try again.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "You do not have permission to transfer all selected devices. Some devices belong to different companies.",
            "Transfer devices action failed. No resources found.": "No devices matched your selection. Please review your device selection and try again.",
            "Transfer devices action failed. No resources processed.": "Failed to process selected devices. Please try to transfer devices again.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "You do not have permission to update all selected devices. Some devices belong to different companies.",
            "Update devices action failed. No resources found.": "No devices matched your selection. Please review your device selection and try again.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "You do not have permission to update attributes for all selected devices. Some devices belong to different companies.",
            "Update devices attributes action failed. No resources found.": "No devices matched your selection. Please review your device selection and try again.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "You do not have permission to update all selected tasks. Some tasks are associated with resources from different companies.",
            "Update tasks action failed. No resources found.": "No tasks matched your selection. Please review your task selection and try again.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension."
        },
        "no notifications": "No notifications",
        "notifications": "Notifications",
        "notifications will be listed": "All new notifications will be listed here",
        "remove notification": "Remove notification",
        "see previous notifications": "See previous notifications",
        "timestamps": {
            "days ago": "{{days}}d ago",
            "hours ago": "{{hours}}h ago",
            "minutes ago": "{{minutes}} min ago",
            "moments ago": "Moments ago"
        },
        "title": {
            "BackgroundActionFailed": "Action failed",
            "CompaniesSuccessfullyDeleted": "Companies successfully deleted",
            "CompanyBulkDeleteFailed": "An error occurred while deleting companies",
            "CompanyLevelChanged": "Company level changed",
            "CompanyLevelDowngradeReminder": "Upcoming company level downgrade",
            "CompanyMergeFailed": "An error occurred while merging companies",
            "CompanySuccessfullyMerged": "Companies successfully merged",
            "DeviceAttributesSuccessfullyUpdated": "Device attributes successfully updated",
            "DeviceBulkAttributeUpdateFailed": "An error occurred while updating device attributes",
            "DeviceBulkUpdateFailed": "An error occurred while updating devices",
            "DeviceExportFailed": "An error occurred while exporting devices",
            "DeviceGroupMoveFailed": "An error occurred while moving device group",
            "DeviceGroupsSuccessfullyDeleted": "Device groups successfully deleted",
            "DeviceGroupSuccessfullyMoved": "Device group successfully moved",
            "DeviceGroupTasksCreateFailed": "An error occurred while creating Smart Group tasks",
            "DeviceGroupTasksSuccessfullyCreated": "Smart Group tasks successfully created",
            "DeviceModelBulkDeleteFailed": "An error occurred while deleting device models",
            "DeviceModelsSuccessfullyDeleted": "Device models successfully deleted",
            "DevicesSuccessfullyTransferred": "Devices successfully transferred",
            "DevicesSuccessfullyUpdated": "Devices successfully updated",
            "DeviceTransferFailed": "An error occurred while transferring devices",
            "ExportFailed": "Resource export failed",
            "ExportSucceeded": "Devices successfully exported",
            "FailedTasksRetryFailed": "An error occurred while retrying tasks",
            "FailedTasksSuccessfullyRetried": "Tasks successfully retried",
            "FileBulkDeleteFailed": "An error occurred while deleting files",
            "FilesSuccessfullyDeleted": "Files successfully deleted",
            "GroupBulkDeleteFailed": "An error occurred while deleting device groups",
            "ImportFailed": "Resource import failed",
            "ImportSucceeded": "Devices successfully imported",
            "ProductCodeBulkDeleteFailed": "An error occurred while deleting product codes",
            "ProductCodesSuccessfullyDeleted": "Product codes successfully deleted",
            "ResourceUpdateFailed": "Resource update failed",
            "ResourceUpdateSucceeded": "Resource update succeeded",
            "RoleBulkDeleteFailed": "An error occurred while deleting roles",
            "RolesSuccessfullyDeleted": "Roles successfully deleted",
            "TaskBulkCancelFailed": "An error occurred while canceling tasks",
            "TaskBulkCreateFailed": "An error occurred while creating a task group",
            "TaskBulkUpdateFailed": "An error occurred while updating tasks",
            "TaskGroupSuccessfullyCreated": "Task group successfully created",
            "TasksPropagationFailed": "Task propagation job failed",
            "TasksPropagationSucceeded": "Task propagation job succeeded",
            "TasksPropagationWarning": "Task propagation job has ended with warnings",
            "TasksSuccessfullyCanceled": "Tasks successfully cancelled",
            "TasksSuccessfullyUpdated": "Tasks successfully updated",
            "UserBulkDeleteFailed": "An error occurred while deleting users",
            "UserExpireReminder": "Your FOTA WEB access will expire soon",
            "UsersSuccessfullyDeleted": "Users successfully deleted"
        }
    },
    "Permission actions": {
        "Access": "TCT integration",
        "Create": "Create",
        "Delete": "Delete",
        "Download": "Download",
        "Export": "Export",
        "Merge": "Merge",
        "Read": "Read",
        "Retry": "Retry",
        "SecretsRead": "Secrets",
        "TctWebAccess": "TCT web",
        "Transfer": "Transfer",
        "Unlock": "Unlock",
        "Update": "Update"
    },
    "Permission groups": {
        "company": "Companies",
        "device": "Devices",
        "device group": "Device groups",
        "file": "Files",
        "role": "Roles",
        "task": "Tasks",
        "task group": "Task groups",
        "token": "Tokens",
        "user": "Users"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "This option is disabled for users with Basic company level.",
                "token list": "API integration tokens are disabled for users with Basic company level."
            },
            "custom_role_support": {
                "create role": "This feature can only be used by users with Premium company level.",
                "edit role": "This feature can only be used by users with Premium company level. Previously created custom roles can be deleted.",
                "edit user": "This feature can only be used by users with Premium company level. Previously assigned custom roles can be removed."
            },
            "task_schedule_support": {
                "table head": "This feature can only be used by users with Standard and Premium company levels. Previously added tasks with schedules will still be executed."
            }
        },
        "general message": "This feature can only be used by users with Standard and Premium company levels.",
        "resource_limit_settings": {
            "tasks_per_group": "You cannot create tasks for more than {{limitCount}} devices at once."
        }
    },
    "Search": {
        "code": "Code",
        "description": "Description",
        "email": "Email",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "Model",
        "name": "Name",
        "product code": "Product code",
        "role name": "Role name",
        "serial": "Serial No.",
        "search by": "Search by",
        "search company name": "Search company name"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "You're about to disable your two-factor authentication. This might make your FOTA WEB account insecure. Are you sure you want to continue?",
                    "title": "Are you sure?"
                },
                "send email code": {
                    "enter code": "For security purposes, please enter the code to verify the email."
                },
                "send otp code": {
                    "description": "A 6-digit code has been sent to your authentication app. For security purposes, please enter the generated code in the field below.",
                    "no access": {
                        "authenticator": "If you no longer have access to the authenticator app linked to this account, a password change is needed to disable the two-factor authentication.",
                        "email": "If you no longer have access to the email linked to this account, a password change is needed to disable the multi-factor authentication."
                    }
                },
                "title": "Disable two-factor authentication"
            },
            "get email code": {
                "description": "Use that code on the next screen to verify your account.",
                "description modal": "Use that code to verify your account.",
                "title": "By pressing \"Send code\", a unique code will be sent to <1>{{email}}</1>."
            },
            "get secret code": {
                "description": "You will need an authenticator mobile app to complete this process, such as one of the following:"
            },
            "select authentication type": {
                "authentication app description": "Get a unique code from an app like Microsoft Authenticator, or Google Authenticator.",
                "description": "To keep your account and client data secure, please use one of the following options to set up Two-Factor Authentication.",
                "description modal": "Select your preferred authenticator method.",
                "email": "Email",
                "email description": "We will send a one-time code to your email whenever you try to sign in.",
                "recommended": "Recommended",
                "title": "Two-factor Authentication (2FA) is mandatory for all FOTA WEB users.",
                "title modal": "Select authentication method"
            },
            "send email code": {
                "description": "Please enter the code in the field below, and press \"Verify\" to proceed.",
                "enter code": "Please enter the code to verify the email.",
                "title": "A unique code was sent to <1>{{email}}</1>.",
                "verification code": "Verification code"
            },
            "send otp code": {
                "click to scan code": "Click here to scan a QR code instead",
                "click to type code": "Click here to manually type the code instead",
                "incorrect code": "Incorrect code",
                "scan QR code": "Scan the QR code into your app",
                "six digit code": "6-digit code generated by your app",
                "title": "You will need an authenticator mobile app to complete this process, such as: <1>Microsoft Authenticator</1> or <2>Google Authenticator</2>.",
                "type text code": "Type the text code into your app"
            },
            "settings": {
                "description": "Codes from your authenticator app or email",
                "disabled": "Disabled",
                "enabled": "Enabled",
                "title": "Two-factor authentication"
            },
            "success message": {
                "alert": "Two-factor authentication successfully enabled.",
                "description": "We will ask for an authentication code any time you log in with your email and password.",
                "title": "You have successfully enabled two-factor authentication.",
                "title modal": "Two-factor authentication Enabled!"
            },
            "title": {
                "authentication app": "Authentication app",
                "authentication email": "Authentication email",
                "is enabled": "Two-factor authentication enabled.",
                "protect your account": "Protect your FOTA WEB account"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "Account",
                "banner": "You will be signed out and your account will be deactivated right away. Personal data is permanently removed on {{date}}.",
                "cancel info": "If you want to cancel the deletion, contact us through our support page by {{date}}. After this date, the account can't be restored.",
                "more info": "Certain information may be retained in audit logs in accordance with our <a>Privacy Notice</a>.",
                "description": "This can't be undone after the grace period ends.",
                "title": "Delete your account?",
                "verification code description": {
                    "authenticator": "Verification code required. Check your authenticator app and enter the code below to delete account.",
                    "email": "A unique code was sent to your email. For security purposes, please enter the generated code in the field below."
                }
            },
            "settings": {
                "description": "You lose access right away. Your data is permanently deleted after 30 days.",
                "title": "Delete account"
            }
        },
        "password": {
            "change password": "Change password",
            "enter current password": "Enter current password",
            "enter new password": "Enter new password",
            "hide password": "Hide password",
            "repeat new password": "Repeat new password",
            "rules": {
                "lowercase letter": "At least one lowercase letter (a-z)",
                "minimum characters": "At least 12 characters",
                "new and current passwords must not match": "New and current passwords must not match",
                "new passwords must match": "New passwords must match",
                "number": "At least one number",
                "passwords must match": "Passwords must match",
                "special symbol": "At least one special symbol (!@#$%^&*()-_=+)",
                "uppercase letter": "At least one uppercase letter (A-Z)"
            },
            "settings": {
                "description": "Last changed: {{date}}",
                "title": "Account password"
            },
            "show password": "Show password"
        },
        "recovery codes": {
            "banner description": "These codes will only be shown once. Store them somewhere safe - like a password manager, a printed copy in a secure location, or an encrypted file.",
            "banner title": "Save codes.",
            "checkbox title": "I have saved my recovery codes.",
            "download error message": "Could not process the codes. The data format is invalid.",
            "first step description": "A 6-digit code has been sent to your authentication app. For security purposes, please enter the generated code in the field bellow.",
            "first step title": "Generate recovery codes",
            "input field title": "Recovery code",
            "print error message": "Unable to open the print window. Please try again or check if your browser is blocking pop-ups.",
            "second step description": "Recovery codes allow you to regain account access if you lose your authentication device or app.",
            "second step title": "Two-factor recovery codes",
            "settings": {
                "title": "Recovery codes",
                "description": "Use them if you lose access to your authenticator app"
            }
        },
        "account": "Account",
        "description": "Manage your sign-in methods and account security.",
        "security": "Security",
        "security and account": "Security & account"
    },
    "Settings": {
        "version": "Version"
    },
    "Statistics": {
        "table statistics": "Table statistics",
        "statistics message": "Table filters will affect statistics that you see below",
        "activity": "Activity",
        "model": "Model",
        "firmware": "Firmware",
        "configuration": "Configuration",
        "statistics": "Statistics"
    },
    "Table": {
        "1_wire_authorization": "1-Wire authorization",
        "access group": "Access group",
        "access groups": "Access groups",
        "access level": "Access level",
        "accessories": "Accessories",
        "action": "Action",
        "action date": "Action date",
        "assigned package": "Assigned package",
        "attempt count": "Attempt count",
        "attribute": "Attribute",
        "attributes": "Attributes",
        "auto sync": "Auto-Sync",
        "batch id": "Batch ID",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE firmware",
        "bluetooth_authorization": "Bluetooth authorization",
        "bootloader": "Bootloader",
        "can_adapter": "CAN Adapter",
        "can adapter name": "CAN adapter name",
        "can bootstring": "Bootstring",
        "can oem file package": "OEM file package",
        "can oem file vehicle": "OEM file vehicle",
        "can package": "CAN package",
        "can program number": "CAN program number",
        "can software date": "CAN software date",
        "can type": "CAN type",
        "carrier module id": "Module ID",
        "carrier revision": "Revision",
        "carrier serial id": "Serial ID",
        "carrier settings filename": "Settings filename",
        "carrier unit status": "Status",
        "carrier unit type": "Unit type",
        "changed at": "Changed at",
        "change origin": "Change origin",
        "changes": "Changes",
        "checkbox disabled": {
            "role": "Static role cannot be edited or deleted."
        },
        "child company": "<0>Child company of</0><1>{{parentCompany}}</1>",
        "child companies": "Child companies",
        "code": "Code",
        "company": "Company",
        "company hierarchy": "Company hierarchy",
        "company name": "Company name",
        "compatibility": "Compatibility",
        "configuration": "Configuration",
        "configuration details": "Configuration details",
        "configuration type": "Configuration type",
        "created at": "Created at",
        "created by": "Created by",
        "date": "Date",
        "description": "Description",
        "device details": "Device details",
        "device company": "Device company",
        "device description": "Device description",
        "device group": "Device group",
        "device imei": "Device IMEI",
        "device model": "Device model",
        "device seen at": "Device seen at",
        "device serial": "Device Serial No.",
        "devices": "Devices",
        "devices count": "Devices count",
        "Done": "Done",
        "download at": "Download at",
        "download file": "Download file",
        "dtb": "DTB",
        "edit file": "Edit file",
        "email": "Email",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "As soon as task groups are created, you'll be able to see the list here",
                    "changes": "As soon as changes are made, you will be able to see the list here",
                    "companies": "As soon as companies are created, you will be able to see the list here",
                    "configurationChanges": "As soon as configuration changes are made, you will be able to see the list here",
                    "desktopLicenses": "As soon as desktop licenses are created, you will be able to see the list here",
                    "devices": "As soon as devices are uploaded to FOTA WEB, you'll be able to see the list here",
                    "files": "As soon as files are uploaded, you will be able to see the list here",
                    "groups": "As soon as groups are created, you will be able to see the list here",
                    "offlineLicenses": "As soon as offline licenses are created, you will be able to see the list here",
                    "permissions": "As soon as permissions are assigned to the user, you will be able to see the list here",
                    "productCodes": "As soon as product codes are created, you will be able to see the list here",
                    "roles": "As soon as roles are created, you will be able to see the list here",
                    "tasks": "As soon as tasks are created, you'll be able to see the list here",
                    "users": "As soon as users are added, you will be able to see the list here"
                },
                "title": {
                    "batches": "Task groups table is empty",
                    "changes": "Changes table is empty",
                    "companies": "Companies table is empty",
                    "configurationChanges": "Configuration changes table is empty",
                    "desktopLicenses": "Desktop licenses table is empty",
                    "devices": "Devices table is empty",
                    "files": "Files table is empty",
                    "groups": "Groups table is empty",
                    "offlineLicenses": "Offline licenses table is empty",
                    "permissions": "Permissions table is empty",
                    "productCodes": "Product codes table is empty",
                    "roles": "Roles table is empty",
                    "tasks": "Tasks table is empty",
                    "users": "Users table is empty"
                }
            },
            "no permission": {
                "description": "Please contact your administrator to request access.",
                "title": "You don't have the necessary permission to view this content"
            },
            "no results found": {
                "description": "Try another keyword or filter to get results",
                "title": "No results found"
            },
            "button": {
                "add": {
                    "companies": "Create company",
                    "devices": "Add device",
                    "files": "Upload file",
                    "groups": "Create group",
                    "productCodes": "Add product code",
                    "tasks": "Create task",
                    "users": "Invite user"
                },
                "reset view": "Reset view"
            }
        },
        "exausted autoscan limit": "Exhausted autoscan limit until",
        "exausted vin parsing limit": "Exhausted VIN parsing limit until",
        "expiration": "Expiration",
        "expiration date": "Expiration date",
        "expires at": "Expires at",
        "expiry date": "Expiry date",
        "field": "Field",
        "file": "File",
        "file id": "File ID",
        "files": "Files",
        "file type": "File type",
        "filter by": "Filter by",
        "firmware": "Firmware",
        "general": "General",
        "general data": "General data",
        "gnss version": "GNSS Version",
        "group": "Group",
        "groups": "Device groups",
        "group vip status": "Group VIP status",
        "gsm number": "GSM number",
        "head title info": {
            "auto synced": {
                "changed at": "Device reported date of the change.",
                "download at": "Date when configuration download task was completed.",
                "synced at": "Server date when the change was reported.",
                "user sent configuration": "File name of sent configuration using \"Upload configuration\" task. This doesn't represent a current configuration on the device. Always up-to-date configuration can be achieved using Auto-Sync feature."
            },
            "platform": {
                "fmx platform": "<1>FMx platform</1> - FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200) and TMT models.",
                "ft platform": "<1>FT platform</1> - FTx and ATx models.",
                "legacy platform": "<1>Legacy platform</1> - FM (excluding FM4001 and FM3010), FMA, and GH (GH4000) models.",
                "title": "Platform generation of the telematics device"
            },
            "visibility": "<2>Changes labeled as <1>Internal</1> are not visible to clients.</2><2>Because device changes may include both visible and hidden data, <1>do not share screenshots or details in external communications</1>.</2>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "Info",
        "interface": "Interface",
        "invited by": "Invited by",
        "items": "items",
        "last checked at": "Last checked at",
        "last sign in": "Last sign in",
        "last status update": "Last status update",
        "last used at": "Last used at",
        "license disabled": "Disabled",
        "license enabled": "Enabled",
        "license key": "License key",
        "license name": "License name",
        "links": "Links",
        "manual_geofence_scenarios": "Manual geofence scenarios",
        "message": "Message",
        "model": "Model",
        "model task type support": {
            "false": "Unsupported",
            "true": "Supported"
        },
        "modem version": "Modem version",
        "name": "Name",
        "new value": "New value",
        "next task": "Next task",
        "no changes": "No changes.",
        "no company name": "No company name",
        "no details": "No details",
        "no file": "No file",
        "no imei available": "No IMEI available",
        "no model": "No model",
        "no parent company": "The company does not have a parent company.",
        "no tasks": "The device has no tasks.",
        "number": "Number",
        "obd": "OBD",
        "obd chip firmware version": "OBD Chip Firmware Version",
        "of": "of",
        "offline licenses tab disabled": "Offline licenses are not available for disabled desktop licenses.",
        "origin": "Origin",
        "original value": "Original value",
        "other information": "Other information",
        "page of": "page of",
        "parent company": "Parent company",
        "permission count": "Permission count",
        "platform": "Platform",
        "Price": "Price",
        "product code": "Product code",
        "program number": "Program number",
        "property": "Property",
        "queue": "Queue",
        "receiving company": "Receiving company",
        "revision": "Revision",
        "role": "Role",
        "role name": "Role name",
        "rows per page": "Rows per page",
        "running": "Running",
        "schedule": "Schedule",
        "seen at": "Seen at",
        "select row": "Select a row to see details",
        "send sms": "Send SMS",
        "serial": "Serial No.",
        "show details": {
            "desktopLicenses": "Show desktop license details",
            "devices": "Show device details",
            "batches": "Show task group details",
            "tasks": "Show task details",
            "companies": "Show company details"
        },
        "sim": "SIM",
        "size": "Size",
        "software date": "Software date",
        "source company": "Source company",
        "spec_id": "Spec. ID",
        "status": "Status",
        "status id": "Status ID",
        "status name": "Status name",
        "supported task types": "Supported task types",
        "synced at": "Synced at",
        "sync mode": "Sync mode",
        "sync status": "Sync status",
        "table columns": "Table columns",
        "target company": "Target company",
        "task id": "Task ID",
        "task queue": "Task queue",
        "tasks": "Tasks",
        "task type": "Task type",
        "tct web support": "TCT web support",
        "total": "Total",
        "type": "Type",
        "updated at": "Updated at",
        "updated by": "Updated by",
        "unknown": "Unknown",
        "user cannot be deleted": "User cannot be deleted.",
        "user cannot be edited": "User cannot be edited.",
        "user cannot delete himself": "A user cannot delete their own profile.",
        "user date statuses": {
            "expired": "Expired",
            "expires": "Expires",
            "never expires": "Never expires",
            "sent": "Sent"
        },
        "user email": "User email",
        "user invitation cannot be cancelled": "User invitation cannot be cancelled.",
        "user invitation cannot be resent": "User invitation cannot be resent.",
        "user sent configuration": "User sent configuration",
        "user statuses": {
            "Active": "Active",
            "Inactive": "Inactive",
            "InvitationExpired": "Expired invitation",
            "InvitationPending": "Pending invitation"
        },
        "users": "Users",
        "value from": "Value from",
        "value to": "Value to",
        "view all roles": "View all ({{count}})",
        "vin": "VIN",
        "vip status": "VIP status",
        "visibility": "Visibility"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "Unknown password explanation",
            "disabled copy tooltip": "Reveal the password to enable copying",
            "unknown": "Unknown",
            "unknown tooltip": "\"Unknown\" means the password origin isn't recorded, typically because it was set via TCT or directly during manufacturing."
        },
        "device details": {
            "configuration": {
                "badge tooltips": {
                    "not supported": "The device doesn't support Auto-Sync feature for this configuration file type.",
                    "sync failed": "The last configuration synchronization task has failed, canceled or it was expired.",
                    "syncing": "Configuration synchronization task is pending or running."
                },
                "configuration details": "Configuration details",
                "mode descriptions": {
                    "Disabled": "Configuration synchronization is disabled.",
                    "Enabled": "Detects changes and synchronizes configuration.",
                    "ReportingOnly": "Detects/registers configuration changes, but doesn't download configuration."
                },
                "mode not supported tooltip": "The device doesn't support Auto-Sync feature for this configuration file type.",
                "mode titles": {
                    "Disabled": "Auto-Sync Off",
                    "Enabled": "Auto-Sync On",
                    "not supported": "Auto-Sync not supported",
                    "ReportingOnly": "Monitor"
                },
                "overview": "Overview",
                "status titles": {
                    "cancelled": "Sync cancelled",
                    "completed": "Sync completed",
                    "failed": "Sync failed",
                    "syncing": "Syncing"
                },
                "status tooltips": {
                    "cancelled": "The last configuration synchronization task was cancelled.",
                    "completed": "The last configuration synchronization task was successfully completed or completed with errors.",
                    "failed": "The last configuration synchronization task has failed or expired.",
                    "syncing": "Configuration synchronization task is pending, running, or verifying."
                },
                "sync history": "Sync history",
                "sync status": "Sync status"
            }
        },
        "device group tasks": "Device group tasks",
        "group tasks": "Group tasks",
        "number of devices": "Number of devices",
        "permissions info": "Permissions info",
        "smart group files": "Smart Group files",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "name of accessory interface.",
                    "type": "connected accessory type."
                },
                "can": {
                    "assigned package": "the OEM package assigned to the device.",
                    "can oem file package": "the OEM package reported during the last connection.",
                    "can oem file vehicle": "the OEM vehicle configuration reported during the last connection.",
                    "dtb": "the version of CAN device tree blob reported during the last connection.",
                    "firmware": "the version of CAN firmware."
                },
                "can_adapter": {
                    "can adapter name": "CAN adapter name parsed from the bootstring.",
                    "can bootstring": "the latest received CAN adapter startup string containing current data and program number of adapter.",
                    "program number": "the program number of the CAN adapter.",
                    "revision": "the revision version of CAN adapter software date.",
                    "software date": "the software date of the CAN adapter.",
                    "type": "the type of CAN adapter."
                },
                "configuration overview": {
                    "BluetoothAuthorizationList": "the Bluetooth authorization list for driver authorization or identification scenarios.",
                    "MainConfiguration": "the main configuration file with all parameters excluding 1-Wire, Bluetooth, and Manual geofence lists.",
                    "ManualGeofenceList": "the Manual geofence list for location-based events.",
                    "OneWireAuthorizationList": "the 1-Wire authorization list for driver authorization."
                },
                "configuration details": {
                    "1_wire_authorization": "the last sent 1-Wire authorization list file name.",
                    "bluetooth_authorization": "the last sent Bluetooth authorization list file name.",
                    "main configuration": "the last sent main configuration file name.",
                    "manual_geofence_scenarios": "the last sent Manual geofence list file name."
                },
                "general": {
                    "ble_dtb": "the version of BLE device tree blob reported during the last connection.",
                    "ble_fw": "the version of BLE firmware reported during the last connection.",
                    "bluetooth password": "the device Bluetooth password that can be revealed when the password is set from FOTA WEB side for users with \"$t(General##Device.SecretsRead)\" permission.",
                    "bootloader": "the version of the device bootloader reported during the last connection.",
                    "company": "the company that owns this device.",
                    "configuration": "the last sent configuration file name.",
                    "description": "the device description (user-defined).",
                    "dtb": "the version of the device tree blob reported during the last connection.",
                    "firmware": "the version of the device firmware reported during the last connection.",
                    "gnss version": "the version of GNSS reported during the last connection.",
                    "group": "the device group this device is assigned to.",
                    "product code": "the device product code.",
                    "serial": "the device serial number."
                },
                "obd": {
                    "obd chip firmware version": "the version of the OBD chip firmware reported during the last connection.",
                    "vin": "a unique 17-character code that identifies a specific motor vehicle."
                },
                "sim": {
                    "gsm number": "the public telephone number associated with a device.",
                    "iccid": "a unique serial number identifying a SIM card.",
                    "imsi": "a unique identifier for a mobile network subscriber."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "configuration file for FMx platform devices assigned to the device group.",
                    "firmware": "firmware file for FMx platform devices assigned to the device group."
                },
                "ft platform files": {
                    "1_wire_authorization_list": "file of authorized 1-Wire devices for FT platform devices assigned to the device group.",
                    "bluetooth_authorization_list": "file of authorized Bluetooth devices for FT platform devices assigned to the device group.",
                    "firmware": "firmware file for FT platform devices assigned to the device group.",
                    "main configuration": "main configuration file for FT platform devices assigned to the device group."
                }
            },
            "users": {
                "general": {
                    "created at": "the date and time of user creation.",
                    "id": "the unique ID of the user.",
                    "invited by": "email address of the user who created the invitation.",
                    "role": "role(s) assigned to the user.",
                    "updated at": "the date and time of the last user update."
                }
            }
        },
        "user details": "User details"
    },
    "Task groups": {
        "all": "All",
        "bulk type": {
            "CompanyBulkDelete": "Delete company",
            "DeviceBulkCreate": "Add device",
            "DeviceBulkDelete": "Delete device",
            "DeviceBulkUpdate": "Update device",
            "FileBulkDelete": "Delete file",
            "GroupBulkDelete": "Delete group",
            "TaskBulkCreate": "Create task",
            "TaskBulkUpdate": "Cancel task",
            "UserBulkDelete": "Delete user"
        },
        "pending approval": "Pending approval",
        "already approved": "Already approved",
        "no approval required": "No approval required",
        "total objects": "Total objects",
        "total tasks": "Total tasks"
    },
    "Task status": {
        "0": "Pending",
        "1": "Running",
        "2": "Completed",
        "3": "Completed with errors",
        "4": "Cancelled",
        "5": "Failed",
        "6": "Expired",
        "7": "Waiting for approval",
        "8": "Verifying",
        "task count": {
            "0": "Pending tasks",
            "1": "Running tasks",
            "3": "Completed with errors tasks",
            "5": "Failed tasks"
        },
        "verified tooltip title": "Task was successfully completed and verified by the device."
    },
    "Tasks": {
        "0": "The task is in the queue and is now pending.",
        "1": "The task is currently running.",
        "2": "The task was successfully completed.",
        "3": "The task was completed, but some errors occurred.",
        "4": "The task was cancelled.",
        "5": "The task was failed.",
        "6": "The task was not completed in a certain time frame."
    },
    "Tct": {
        "edit configuration": "Edit configuration",
        "no editable configurations": "No editable configurations are uploaded",
        "open tct": "Open TCT web version",
        "open tct description": "Choose to create a new configuration in TCT web version, or edit an existing configuration file from FOTA WEB.",
        "select configuration file": "Select a configuration file you wish to edit in TCT web.",
        "tct web": "TCT web",
        "tct web disabled description": "TCT web version is only available for Premium company level."
    },
    "Tutorial": {
        "buttons": {
            "exit": "Exit",
            "finish": "Finish",
            "get started": "Get started",
            "next": "Next",
            "next feature": "Next feature"
        },
        "content": {
            "company selector": {
                "0": "On the top navigation bar you will see the company selector option. Clicking on the button will open a selection, that allows you to choose any number of companies you wish to work with in FOTA.",
                "1": "This screen allows you to select a specific company, or number of companies to work with. You will only see lists related to the companies that have been selected. Logging out of FOTA will always save the last used selection.",
                "1-info": "\n\nIf you wish to move on to the next feature tutorial, press the \"$t(Tutorial##buttons##next feature)\" button."
            },
            "finish tutorial": "You have completed the tutorial. If at any time you wish to go through the tutorial again, you can do so through the settings screen.",
            "first time user": "Welcome to FOTA WEB tutorial mode. In this mode we will guide you through some of the new features of FOTA WEB.\nIf you wish to exit the tutorial, press the \"$t(Tutorial##buttons##exit)\" button at the bottom of your screen. If you wish to start the tutorial again at any time, you can do so from the settings.\n\nTo begin, press the \"$t(Tutorial##buttons##get started)\" button.",
            "task groups": {
                "desktop": {
                    "0": "Task groups are located on the left side navigation bar. Selecting Task groups option will take you to that page.",
                    "1": "This is the Task groups screen. Any bulk task created for more than one device will appear in the table view together with the status of each task inside the task group. More detailed information can be discovered in details by selecting a row."
                },
                "mobile": {
                    "0": "Task groups are located inside the menu, along other options.",
                    "1": "Opening the menu and selecting Task groups option will take you to that page."
                }
            }
        },
        "titles": {
            "finish tutorial": "Tutorial completed!",
            "first time user": "Welcome to FOTA WEB.",
            "tutorial mode": "Tutorial mode"
        }
    }
}
